﻿import InputLabel from './components/input-labels';
import SelectLabel from './components/select-labels';
import CarCustomiser from './components/car-customiser';
import TabGroup from './components/tab-groups';
import StockSlider from './components/stock-slider';
import StockFilter from './components/stock-filters';
import StockSearch from './components/stock-search';
import PresalesCountdown from './components/presales-countdown';
import ComparisonSlider from './components/comparison-slider';

import CarFinder from './components/car-finder-v2';

import Nav from './components/nav';

// Range slider
// https://refreshless.com/nouislider/  

function getURLParameter(name) {
    var match = RegExp('[?&#]' + name + '=([^&]*)').exec(window.location.href);
    if (match == null) {
        return null;
    }
    else {
        return match[1].toString();
    }
}

function currencyFormat(_number) {
    return new Intl.NumberFormat().format(_number);
}

function updateDropdown(_dropdownElementId, _firstOptionText, _optionsArr, _disable) {
    var _dropdown = document.getElementById(_dropdownElementId);

    document.querySelectorAll('#' + _dropdownElementId + ' option').forEach(option => option.remove());

    if (_optionsArr.length > 1) {
        var option = document.createElement("option");
        option.text = _firstOptionText;
        option.value = '';
        _dropdown.add(option);
    }

    _optionsArr.forEach(function (e) {
        var option = document.createElement("option");
        option.text = e;
        option.value = e;
        _dropdown.add(option);
    });

    _dropdown.disabled = _disable;
}


$(function () {
    if ($('.custom-upload-wrapper').length > 0) {
        $('.custom-upload-wrapper').on('change', '.custom-file-input', function () {
            var wrapper = $(this).parents('.custom-upload-wrapper');
            var filename = wrapper.find('.custom-upload-file-name');
            var f = $(this).val();
            f = f.replace(/.*[\/\\]/, '');
            filename.text(f);
        });
    }

    // END:jQuery  
});

window.dataLayer = window.dataLayer || [];
var vwdata = window.vwdata = window.vwdata || [];
window.VOLKSWAGEN = {};

VOLKSWAGEN.StartComponents = (function () {
    return {        
        init: function (element) {
            new InputLabel('*[data-component="c-input-label"]', element);           
            new SelectLabel('*[data-component="c-select-label"]', element);
            new CarCustomiser('*[data-component="c-customiser"]', element);
            new TabGroup('*[data-component="c-tabs"]', element);
            new StockSlider('*[data-component="c-stock-slider"]', element);
            new StockFilter('*[data-component="c-stock-filter"]', element);
            new StockSearch('*[data-component="c-stock-search"]', element);
            new PresalesCountdown('*[data-component="presales-countdown"]', element);
            new CarFinder('*[data-component="c-car-finder"]', element);
            new Nav('*[data-component="c-nav"]', element);
        }
    };
}());

VOLKSWAGEN.StartComponents.init(document);


VOLKSWAGEN.CityDealer = (function () {

    function updateDealers(_type, selectedCity, dealerRadioBtns) {
        
        var _url = '/app/nz/api/dealers/getall';

        $.ajax({
            type: 'GET',
            url: _url + '?type=' + _type,
            success: function (data) {           
                var dealerList = [];
                JSON.parse(data, function (key, value) {
                    if (value != null && value.Location === selectedCity) dealerList.push(value);
                    return value;
                });

                dealerRadioBtns.empty();
                $.each(dealerList, function (index, value) {

                    var _div = document.createElement('label');
                    _div.setAttribute('class', "StyledLabel CustomStyledRadioButtonControl dealer-choice");
                    dealerRadioBtns.append(_div);

                    var theInput = document.createElement("input");
                    theInput.setAttribute('type', "radio");
                    theInput.setAttribute('class', "StyledInput");
                    theInput.setAttribute('name', 'dealer');
                    theInput.setAttribute('value', value.DealerGUID);
                    theInput.setAttribute('id', value.DealerGUID);
                    theInput.setAttribute('data-val', 'true');
                    theInput.setAttribute('data-rule-required', 'true');
                    theInput.setAttribute('data-msg-required', 'Please select a dealer');

                    _div.append(theInput);

                    var StyledFocusWrapper = document.createElement('span');
                    StyledFocusWrapper.setAttribute('class', "StyledFocusWrapper");          

                    var StyledRadioWrapper = document.createElement('span');
                    StyledRadioWrapper.setAttribute('class', "StyledRadioWrapper");  

                    var StyledRadio = document.createElement('span');
                    StyledRadio.setAttribute('class', "StyledRadio");  

                    StyledRadioWrapper.append(StyledRadio);
                    StyledFocusWrapper.append(StyledRadioWrapper);


                    var StyledTextWrapper = document.createElement('span');
                    StyledTextWrapper.setAttribute('class', "StyledTextWrapper");  

                    var StyledTextComponent = document.createElement('span');
                    StyledTextComponent.setAttribute('class', "StyledTextComponent");
                    StyledTextComponent.innerHTML += (value.Suburb) ? (value.DealerDisplayName + ' - ' + value.Suburb) : value.DealerDisplayName;

                    StyledTextWrapper.append(StyledTextComponent);
                    StyledFocusWrapper.append(StyledTextWrapper);                   


                    _div.append(StyledFocusWrapper);
                });

                var _validationSpan = document.createElement('span');
                _validationSpan.setAttribute('class', 'field-validation-valid');
                _validationSpan.setAttribute('data-valmsg-for', 'dealer');
                _validationSpan.setAttribute('data-valmsg-replace', 'true');
                dealerRadioBtns.append(_validationSpan);             

            },
            error: function (response) {
                console.log(response);
            }
        });
    }

    return {
        init: function () {

            var $field = $('.js-citydealers');
            if (!$field.length) { return false; }

            $field.each(function () {
                var $cityDropdown = $(this).find('.js-citydealers-city');
                var $dealerField = $(this).find('.js-dealer-field');
                var $dealerRadioBtns = $(this).find('.js-citydealers-dealers');
                var $hiddenField = $(this).find('.js-citydealers-hidden');
                var $type = $field.data('dealertype');

                $dealerField[0].style.display = "none";

                $(this).on('change', '.js-citydealers-city', function () {
                    if ($cityDropdown.val() === '') {
                        $dealerField[0].style.display = "none";
                    }
                    else {
                        $dealerField[0].style.display = "initial";
                        updateDealers($type, $cityDropdown.val(), $dealerRadioBtns);
                    }                   
                });

                $dealerRadioBtns.on('click', '.dealer-choice', function (e) {
                    var selectedDealerGUID = $(this)[0].querySelector('input[name="dealer"]').value;
                    var dealerName = $(this)[0].innerText;
                    $hiddenField.val(dealerName + ' [' + selectedDealerGUID + ']');
                });

            });

        }
    };
}());

VOLKSWAGEN.CityDealer.init();


VOLKSWAGEN.TestDriveAndBrochure = (function () {
    var $form = ''; // decide test drive form or brochure request form
    var isTD = true;
    var $selectedVehicleNames = [];
    var $modelsSelected = $('.js-total-selected');
    var $selectedTerm = $('.selected-term');
    var $rangeTotalModels = $('.js-total-models');
    var $filterTerm = $('.filter-term');
    var $filterResetBtn = $('.js-reset-filter');
    var $selectedModelsWrap = $('.selected-models-wrap');

    var $mobileFilterPanel = $('.mobile-filter-panel');
    var $mobileFilterClose = $('.mobile-filter-panel .close');
    var $mobileOpenFilter = $('.mobile-open-filter');
    var $mobileResultsButton = $('.mobile-results-button');

    var totalModels = 0;
    var currentTotalModels = 0;
    var $selectedRangeNames = [];

    var $scrollToForm = $('.scroll-to-link');
    var $selectedDealerName = '';
    
    function initTotalModels() {
        var rangeTabs = document.querySelectorAll('input[type="checkbox"][name="range"]');
        rangeTabs.forEach(function (e) {
            totalModels += parseInt($(e).attr('data-rangeCount'));
        });
        $rangeTotalModels.each(function () {            
            $(this).text(totalModels);            
        });
    }

    function updateFormHiddenFields(_form, _selectedVehicleNameArr, _preSelectedModelName) {
        var carModel = _form.find('.umbraco-forms-field.carmodel input:hidden')[0];
        carModel.value = _selectedVehicleNameArr[0];

        var additionalModels = _form.find('.umbraco-forms-field.additionalmodels input:hidden')[0];
        additionalModels.value = _selectedVehicleNameArr.filter(x => x != _selectedVehicleNameArr[0]);

        if (isTD && _preSelectedModelName.length > 0) {
            var _formTitle = 'Test drive your ' + _preSelectedModelName;
            _form.find('h4.umbraco-forms-caption').text(_formTitle);
        }
    }

    function updateView(_selectedVehicleNameArr, isPreSelected) {
        //form, scroll btn and selected model wrapper

        $modelsSelected[0].innerText = _selectedVehicleNameArr.length;
        if (_selectedVehicleNameArr.length == 1) { $selectedTerm[0].innerText = 'model'; } else { $selectedTerm[0].innerText = 'models'; }

        if (_selectedVehicleNameArr.length > 0) {
            $form[0].style.display = 'block';
            if (!isPreSelected) {
                $scrollToForm[0].style.display = 'inline-block';
            }            
            $selectedModelsWrap[0].style.display = 'inline-block';
        }
        else {
            $form[0].style.display = 'none';
            $scrollToForm[0].style.display = 'none';
            $selectedModelsWrap[0].style.display = 'none';
        }
    }

    function toggleRange() {
        $('input[type="checkbox"][name="range"]').on('change', function () {
            var _rangeName = this.value;
            var _rangeCount = $(this).attr('data-rangeCount');
            
            var i = $selectedRangeNames.indexOf(_rangeName);
            if (i > -1) {
                $selectedRangeNames.splice(i, 1);
                currentTotalModels -= parseInt(_rangeCount);
            }
            else {
                $selectedRangeNames.push(_rangeName);
                currentTotalModels += parseInt(_rangeCount);                
            }

            loadVehicleList($selectedRangeNames, $selectedVehicleNames).then(function (data) {
                $('#car-tiles').html(data);
            }).catch(function (err) {
                console.log(err);
            });

            if (currentTotalModels > 0) {
                $filterResetBtn[0].style.display = 'inline-block';
            }
            else {
                $filterResetBtn[0].style.display = 'none';
            }

            var newModelCount = (currentTotalModels == 0) ? totalModels : currentTotalModels;
            $rangeTotalModels.each(function () {                
                $(this).text(newModelCount);
            });

            if (currentTotalModels == 1) { $filterTerm[0].innerText = 'model'; } else { $filterTerm[0].innerText = 'models'; }

            dataLayer.push({
                'event': _rangeName + 'TypeClick',
                'selectedRanges': $selectedRangeNames
            });


            if (isTD) {
                vwdata.push({
                    eventInfo: {
                        eventAction: 'VWBasic_FilterSearchResultForm_Load',
                        pageId: window.location.href.replace(/http(s?):\/\//g, ''),
                        pageName: 'Test Drive',
                        brand: 'passenger',
                        pageCategory: 'models'
                    },
                    environment: {
                        applicationId: 'VWLocalNZTestdriveD6',
                        language: 'en',
                        country: 'NZ'
                    },
                    user: {
                        browserResolutionHeight: window.screen.width.toString(),
                        browserResolutionWidth: window.screen.height.toString(),
                        browserResolutionOrientation: window.screen.width > window.screen.height ? "h" : "v"
                    },
                    form: {
                        FormType: 'testdrive',
                        FormName: 'testdrive',
                        FormVersion: '1',
                        FormStart: false
                    },
                    filter: {
                        filterlist: [{
                            type: 'multi_value',
                            name: 'CA',
                            values: $selectedRangeNames
                        }]
                    }
                });
            }


        });
    }

    function toggleVehicle() {
        $('#car-tiles').on('click', '.js-card-model', function () {
            var _carName = $(this)[0].getAttribute('data-modelname');
            var btnLink = this.getElementsByClassName("StyledButtonLink")[0];

            var i = $selectedVehicleNames.indexOf(_carName);
            if (i > -1) {
                $selectedVehicleNames.splice(i, 1);
                $(btnLink).removeClass('selected');
                btnLink.text = 'Select';
            }
            else {

                // temporary only allow to select single car model.
                if ($form[0].id === 'brochureRequest') { 
                    //undo for previous selected car model tile
                    var _qText = '.js-card-model[data-modelname="' + $selectedVehicleNames[0] + '"]';
                    var _previousModelTile = document.querySelector(_qText);
                    $selectedVehicleNames = [];

                    if (_previousModelTile != null) {
                        var _previousBtnLink = _previousModelTile.getElementsByClassName("StyledButtonLink")[0];
                        $(_previousBtnLink).removeClass('selected');
                        _previousBtnLink.text = 'Select';
                    }         
                }

                $selectedVehicleNames.push(_carName);
                $(btnLink).addClass('selected');
                btnLink.text = 'Selected';
            }

            // update form hidden fields
            updateFormHiddenFields($form, $selectedVehicleNames, '');

            updateView($selectedVehicleNames, false);

            dataLayer.push({
                'event': 'modelSelected',
                'selectedModels': $selectedVehicleNames
            });


            if (isTD) {
                vwdata.push({
                    eventInfo: {
                        eventAction: 'VWBasic_VehicleSelect_Click',
                        pageId: window.location.href.replace(/http(s?):\/\//g, ''),
                        pageName: 'Test Drive',
                        brand: 'passenger',
                        pageCategory: 'models',
	                    contentId: _carName
                    },
                    environment: {
                        applicationId: 'VWLocalNZTestdriveD6',
                        language: 'en',
                        country: 'NZ'
                    },
                    user: {
                        browserResolutionHeight: window.screen.width.toString(),
                        browserResolutionWidth: window.screen.height.toString(),
                        browserResolutionOrientation: window.screen.width > window.screen.height ? "h" : "v"
                    },                    
                    configuration: {
                        CarlineName: _carName
                    },
                    link: {
                        url: 'function(select)',
                        name: 'vehicleSelect'
                    }
                });                

            }

        });
    }

    function loadVehicleList(_rangeArr, _selectedModelArr) {
        return new Promise(function (resolve, reject) {
            var _url = '/app/nz/api/vehicles/tiles';
            $.ajax({
                type: 'GET',
                url: _url,
                data: {
                    "rangeArr": JSON.stringify(_rangeArr),
                    "selectedModels": JSON.stringify(_selectedModelArr),
                    "isTestDrive": isTD,
                    "isBrochure": !isTD,
                },
                success: function (data) {
                    resolve(data);
                },
                error: function (err) {
                    reject(err);
                }
            });
        });        
    }

    function preSelectedVehicleHandler() {
        var _carName = decodeURI(getURLParameter('vwmodel'));
        if (!!_carName) {
            var _qText = '.js-card-model[data-modelname="' + _carName + '"]';
            var _vehicleTile = document.querySelector(_qText);

            if (_vehicleTile) {
                $selectedVehicleNames.push(_carName);
                updateFormHiddenFields($form, $selectedVehicleNames, _carName);
                updateView($selectedVehicleNames, true);

                $('body,html').animate({
                    scrollTop: $($form).offset().top   //$(_vehicleTile).offset().top - 120
                },
                    800);

                var _btnLink = _vehicleTile.getElementsByClassName('StyledButtonLink')[0];
                $(_btnLink).addClass('selected');
                _btnLink.text = 'Selected';
            }
        }
    }

    function filterReset() {
        //reset all range checkboxes
        var _rangeLinks = document.querySelectorAll('.CustomStyledCheckboxControl .StyledInput');
        _rangeLinks.forEach(function (e) {
            $(e)[0].checked = false;
        });

        $selectedRangeNames = [];
        currentTotalModels = 0;

        $rangeTotalModels.each(function () {
            $(this).text(totalModels);
        });

        if (totalModels == 1) { $filterTerm[0].innerText = 'model'; } else { $filterTerm[0].innerText = 'models'; }
        $filterResetBtn[0].style.display = 'none';

        loadVehicleList($selectedRangeNames, $selectedVehicleNames).then(function (data) {
            $('#car-tiles').html(data);
        }).catch(function (err) {
            console.log(err);
        });

        if (isTD) {
            vwdata.push({
                eventInfo: {
                    eventAction: 'VWBasic_FilterSearchResultForm_Load',
                    pageId: window.location.href.replace(/http(s?):\/\//g, ''),
                    pageName: 'Test Drive',
                    brand: 'passenger',
                    pageCategory: 'models'
                },
                environment: {
                    applicationId: 'VWLocalNZTestdriveD6',
                    language: 'en',
                    country: 'NZ'
                },
                user: {
                    browserResolutionHeight: window.screen.width.toString(),
                    browserResolutionWidth: window.screen.height.toString(),
                    browserResolutionOrientation: window.screen.width > window.screen.height ? "h" : "v"
                },
                form: {
                    FormType: 'testdrive',
                    FormName: 'testdrive',
                    FormVersion: '1',
                    FormStart: false
                },
                filter: {
                    filterlist: undefined
                }
            });
        }

    }

    function mobileFilterOpen() {
        $mobileFilterPanel.fadeIn(160);
    }

    function mobileFilterClose() {
        $mobileFilterPanel.fadeOut(160);
    }    

    return {
        init: function () {
            if ($('#testDriveEnquiry').length) {
                $form = $('#testDriveEnquiry');
            }
            else {
                $form = $('#brochureRequest');
                isTD = false;
            }

            if (!$form.length) { return false; }

            $form[0].style.display = 'none';
            $filterResetBtn[0].style.display = 'none';
            $scrollToForm[0].style.display = 'none';
            $selectedModelsWrap[0].style.display = 'none';

            initTotalModels();
            loadVehicleList($selectedRangeNames, $selectedVehicleNames).then(function (data) {
                $('#car-tiles').html(data);
                preSelectedVehicleHandler();

            }).catch(function (err) {
                console.log(err);
            });
                                    
            toggleRange();
            toggleVehicle();

            $filterResetBtn.on('click', function () {
                filterReset();
            });

            $mobileOpenFilter.on('click', function () {
                mobileFilterOpen();
            });

            $mobileFilterClose.on('click', function () {
                mobileFilterClose();
            });

            $mobileResultsButton.on('click', function () {
                mobileFilterClose();
            });


            $('.scroll-to-link').on('click', function (event) {
                event.preventDefault();
                $('body,html').animate({
                    scrollTop: $form.offset().top
                },
                    800, function () { $('.scroll-to-link').fadeOut(); }
                );
            });


            $('.js-citydealers').each(function () {
                var $dealerRadioBtns = $(this).find('.js-citydealers-dealers');

                $dealerRadioBtns.on('click', '.dealer-choice', function (e) {                    
                    var dealerName = $(this)[0].innerText;
                    $selectedDealerName = dealerName;
                });

            });


            if (isTD) {
                vwdata.push({
                    eventInfo: {
                        eventAction: 'VWBasic_FilterSearchResultForm_Pageload',
                        pageId: window.location.href.replace(/http(s?):\/\//g, ''),
                        pageName: 'Test Drive',                        
                        brand: 'passenger',
                        pageCategory: 'models'
                    },
                    environment: {
                        applicationId: 'VWLocalNZTestdriveD6',
                        language: 'en',
                        country: 'NZ'
                    },
                    user: {                        
                        browserResolutionHeight: window.screen.width.toString(),
                        browserResolutionWidth: window.screen.height.toString(),                        
                        browserResolutionOrientation: window.screen.width > window.screen.height ? "h" : "v"
                    },                    
                    form: {
                        FormType: 'testdrive',
                        FormName: 'testdrive',
                        FormVersion: '1',
                        FormStart: true
                    }
                });

                $('#testDriveEnquiry').on('click', '.vw-formsubmit-button', function () {

                    var configVehicleList = [];
                    for (var i = 0; i < $selectedVehicleNames.length; i++) {
                        configVehicleList.push({ "CarlineName": $selectedVehicleNames[i] });
                    }

                    vwdata.push({
                        eventInfo: {
                            eventAction: 'VWBasic_MultipleVehiclesFormCTA_Click',
                            pageId: window.location.href.replace(/http(s?):\/\//g, ''),
                            pageName: 'Test Drive',
                            contentId: 'submit form',
                            brand: 'passenger',
                            pageCategory: 'models'
                        },
                        environment: {
                            applicationId: 'VWLocalNZTestdriveD6',
                            language: 'en',
                            country: 'NZ'
                        },
                        user: {
                            browserResolutionHeight: window.screen.width.toString(),
                            browserResolutionWidth: window.screen.height.toString(),
                            browserResolutionOrientation: window.screen.width > window.screen.height ? "h" : "v"
                        },
                        form: {
                            FormType: 'testdrive',
                            FormName: 'testdrive',
                            FormVersion: '1'
                        },
                        configuration: {
                            vehicleList: configVehicleList
                        },
                        link: {
                            url: 'function(submit)',
                            name: 'submit form'
                        },
                        partner: {
                            informationName: $selectedDealerName,
                            informationZIP: undefined,
	                        informationDepartment: 'Sales',
	                        informationBnr: undefined
                        }
                    });

                });


                $('#testDriveEnquiry').on('submit', 'form', function () {

                    var configVehicleList = [];
                    for (var i = 0; i < $selectedVehicleNames.length; i++) {
                        configVehicleList.push({ "CarlineName": $selectedVehicleNames[i] });
                    }

                    vwdata.push({
                        eventInfo: {
                            eventAction: 'VWBasic_MultipleVehiclesFormSubmissionSuccessMessage_Load',
                            pageId: window.location.href.replace(/http(s?):\/\//g, ''),
                            pageName: 'Test Drive',
                            contentId: 'success message',
                            brand: 'passenger',
                            pageCategory: 'models'
                        },
                        environment: {
                            applicationId: 'VWLocalNZTestdriveD6',
                            language: 'en',
                            country: 'NZ'
                        },
                        user: {
                            browserResolutionHeight: window.screen.width.toString(),
                            browserResolutionWidth: window.screen.height.toString(),
                            browserResolutionOrientation: window.screen.width > window.screen.height ? "h" : "v"
                        },
                        form: {
                            FormType: 'testdrive',
                            FormName: 'testdrive',
                            FormVersion: '1'
                        },
                        configuration: {
                            vehicleList: configVehicleList
                        },
                        partner: {
                            informationName: $selectedDealerName,
                            informationZIP: undefined,
                            informationDepartment: 'Sales',
                            informationBnr: undefined
                        }
                    });

                });

            }

        }
    };
}());

VOLKSWAGEN.TestDriveAndBrochure.init();


VOLKSWAGEN.VehicleRecall = (function () {
    var $validateRegoBtn = $('#js-validateRecallRego');
    var $submitBtn = null;

    function validateRego() {
        var $recallRego = $('#recallRego');
        var _rego = $recallRego.val();
        if (typeof (_rego) == 'undefined' || _rego == null || _rego == '') {
            console.log('Required Rego');
            //TODO
            return;
        }

        _rego = _rego.replace(/\s+/g, '');
        var _campaignNo = $('#recallCampaignNo').val();

        var $campaignGuid = $('.umbraco-forms-field.campaignguid input:hidden')[0];
        var $campaignName = $('.umbraco-forms-field.recallcampaignname input:hidden')[0];
        var $regoErrorMsg = $('.js-validateRego-error-msg')[0];
        var $regoSuccessMsg = $('.js-validateRego-success-msg')[0];

        var _url = '/app/nz/api/recalls/validate';
        $.ajax({
            type: 'POST',
            url: _url,
            data: { vehicleRegistration: _rego, campaignNo: _campaignNo },
            success: function (response) {
                //console.log(response);
                if (response.CarModel != null && response.RecallCampaignName != null) {
                    $campaignGuid.value = response.RecallCampaignId;
                    $campaignName.value = response.RecallCampaignName;
                    $recallRego[0].readOnly = true;
                    var _msgTxt = $regoSuccessMsg.innerText.replace("{carModel}", response.CarModel)
                        .replace("{brand}", response.Brand)
                        .replace("{recallCampaignName}", response.RecallCampaignName);

                    $regoSuccessMsg.innerText = _msgTxt;
                    $regoSuccessMsg.style.display = "block";
                    $regoErrorMsg.style.display = "none";
                    $validateRegoBtn[0].style.display = "none";

                    $submitBtn.closest('.forms-submit-row').style.cursor = 'pointerd';
                    $submitBtn.style.pointerEvents = 'auto';
                }
                else {
                    $regoErrorMsg.style.display = "block";
                }
            
            },
            error: function (response) {
                console.log(response);
            }
        });
    }

    function getVehicleOwnerDetails(code) {
        var $firstName = $('.umbraco-forms-field.firstname input:text')[0];
        var $lastName = $('.umbraco-forms-field.lastname input:text')[0];
        var $email = $('.umbraco-forms-field.email input:text')[0];
        var $mobile = $('.umbraco-forms-field.mobile input:text')[0];

        var _url = '/app/nz/api/recalls/getcustomer?code=' + code;
        $.ajax({
            type: 'POST',
            url: _url,
            success: function (response) {
                //console.log(response);
                $firstName.value = response.FirstName;
                $lastName.value = response.LastName;
                $email.value = response.Email;
                $mobile.value = response.Mobile;
            },
            error: function (response) {
                console.log(response);
            }
        });

    }

    return {
        init: function () {

            var $form = $('#vehicleRecall');
            if (!$form.length) { return false; }

            var _clientCode = getURLParameter('code');
            if (!!_clientCode) {
                var $code = $('.umbraco-forms-field.code input:hidden')[0];
                $code.value = _clientCode;
                getVehicleOwnerDetails(_clientCode);
            }

            $validateRegoBtn.on('click', function () {
                validateRego();
            });

            $submitBtn = $($form).find('.vw-formsubmit-button')[0];
            $submitBtn.closest('.forms-submit-row').style.cursor = 'not-allowed';
            $submitBtn.style.pointerEvents = 'none';
        }
    };
}());

VOLKSWAGEN.VehicleRecall.init();


VOLKSWAGEN.UpdateDetails = (function () {

    function getCustomerDetails(code) {
        var $firstName = $('.umbraco-forms-field.firstname input:text')[0];
        var $lastName = $('.umbraco-forms-field.lastname input:text')[0];
        var $companyName = $('.umbraco-forms-field.companyname input:text')[0];
        var $email = $('.umbraco-forms-field.email input:text')[0];
        var $mobile = $('.umbraco-forms-field.mobile input:text')[0];
        var $home = $('.umbraco-forms-field.home input:text')[0];

        var $address1 = $('.umbraco-forms-field.address1 input:text')[0];
        var $address2 = $('.umbraco-forms-field.address2 input:text')[0];
        var $city = $('.umbraco-forms-field.city input:text')[0];
        var $postcode = $('.umbraco-forms-field.postcode input:text')[0];

        var _url = '/app/nz/api/owners/getdetails?code=' + code;
        $.ajax({
            type: 'POST',
            url: _url,
            success: function (response) {
                //console.log(response);
                $firstName.value = response.FirstName;
                $lastName.value = response.LastName;
                $companyName.value = response.CompanyName;
                $email.value = response.Email;
                $mobile.value = response.Mobile;
                $home.value = response.Landline;
                $address1.value = response.Address1;
                $address2.value = response.Suburb;
                $city.value = response.City;
                $postcode.value = response.Postcode;
            },
            error: function (response) {
                console.log(response);
            }
        });

    }

    return {
        init: function () {
            var $form = $('#updateDetails');
            if (!$form.length) { return false; }

            var _clientCode = getURLParameter('code');
            if (!!_clientCode) {
                getCustomerDetails(_clientCode);
            }
        }
    };
}());

VOLKSWAGEN.UpdateDetails.init();


VOLKSWAGEN.FindDealer = (function () {
    var $dealerList = $('.js-vw-fadbas')[0];
    var selectedCity = '';
    var selectedDealerType = '';
    var $formGuid = '';
    var formToOpen = ''; 
    var $typeLinks = document.querySelectorAll(".js-dealerFilter a");

    var $fadList = document.getElementById('dealer-cards');
    var $fadMap = document.getElementById('js-fad-map');

    var map = '';
    var $dealers = '';
    var $markers = [];
    var $infowindows = [];
    var $mapGrayout = $('.map-overlap');
    var isNoResult = false;

    const serviceOptions = [
        { key: 'Sales', notFoundText: 'dealerships' },
        { key: 'Service', notFoundText: 'certified service centre' },
        { key: 'Collision Repairs', notFoundText: 'certified collision repairers' }
    ];

    function triggerDealerFilter() {
        if ($dealerList) {
            loadDealerList(selectedCity, selectedDealerType, $formGuid);            
        }        
    }

    function loadDealerList(_city, _dealerType, _form) {
        var _url = '/app/nz/api/fadbas/dealerlist';
        $.ajax({
            type: 'GET',
            url: _url,
            data: {
                "location": _city,
                "type": _dealerType,
                "form": _form
            },
            success: function (data) {
                $('#dealer-cards').html(data);

                var msgEle = document.getElementById('dealer-cards-empty');
                if (data.length < 10) {                    
                    document.querySelector('.js-fad-empty-service').innerText = serviceOptions.find(x => x.key === _dealerType).notFoundText;
                    document.querySelector('.js-fad-empty-city').innerText = _city;
                    msgEle.style.display = 'block';
                    if ($fadMap.style.display != 'none') {
                        $mapGrayout[0].style.display = 'block';   
                    }                       
                    isNoResult = true;
                }
                else {
                    msgEle.style.display = 'none';
                    $mapGrayout[0].style.display = 'none';
                    isNoResult = false;
                }
            },
            error: function (response) {
                console.log(response);
            }
        });
    }

    function updateTypeLinkClass() {
        $typeLinks.forEach(function (e) {
            if (e.text == selectedDealerType) {
                $(e).addClass('is-active').removeClass('not-active');
                $formGuid = e.getAttribute('data-formguid');
            }
            else {
                $(e).removeClass('is-active').addClass('not-active');
            }
        });
    }


    function mapUpdateDealers(_city, _dealerType, _form) {
        return new Promise(function (resolve, reject) {
            var _url = '/app/nz/api/fadbas/dealerjson';
            $.ajax({
                type: 'POST',
                url: _url,
                data: {
                    "location": _city,
                    "type": _dealerType,
                    "form": _form
                },
                success: function (data) {    
                    resolve(data);
                },
                error: function (err) {
                    reject(err);
                }
            });
        });        
    }

    function mapAddMarkers() {
        if ($dealers.length == 0) {
            var marker = new google.maps.Marker({
                position: { lat: -36.8426285, lng: 174.7675404 },
                map: map,
                icon: {
                    url: 'https://maps.google.com/mapfiles/kml/shapes/caution.png'
                }
            });

            $markers.push(marker);
        }        
        else {
            $dealers.forEach(function (x) {
                var marker = new google.maps.Marker({
                    position: { lat: parseFloat(x.Geolocation.Latitude), lng: parseFloat(x.Geolocation.Longitude) },
                    map: map,
                    icon: {
                        url: '/app/nz/resources/img/poi.svg',
                    }
                });

                mapSetInfoWindow(marker, x);
                $markers.push(marker);
            });
        }        
    }

    function mapCleanMarkers() {
        $markers.forEach(function (x) {
            x.setMap(null);
        });
        $markers = [];
    }

    function mapSetInfoWindow(_marker, _dealer) {
        var _id = 'infowindow-' + _dealer.DealerId;

        var contentString = '<div id="' + _id + '">' +
            '<h3>' + _dealer.DealerDisplayName + '</h3>' +
            '<div class="bodyContent">' +
            '<h4>contact details</h4>' +
            '<div class="dealer-contactinfo">' +
            '<div class="dealer-contactaddress"><p>' + _dealer.Address + '</p></div>';

            if (_dealer.Phone || _dealer.Email) { contentString += '<div class="dealer-contactlinks">';}

            if (_dealer.Phone) {                
                contentString += '<a class="dealer-tel" href="tel:' + _dealer.Phone + '">' + _dealer.Phone + '</a><br/>';
            }

            if (_dealer.Email) {
                contentString += '<a class="dealer-email" href="mailto:' + _dealer.Email + '">' + _dealer.Email + '</a>';
            }

            if (_dealer.Phone || _dealer.Email) { contentString += '</div>'; }


            contentString += '</div>';

        if (_dealer.FormGUID || _dealer.WebsiteUrl) { contentString += '<div class="dealer-buttons">'; }

            if (_dealer.FormGUID) {
                contentString += '<button class="js-mapBookBtn StyledSubmitButton vw-dealerbutton-book" data-dealername="' + _dealer.DealerDisplayName +'" data-dealerguid="' + _dealer.DealerGUID +'">Book</button>';
            }

            if (_dealer.WebsiteUrl) {
                contentString += '<a class="StyledButtonLink vw-dealerbutton-web" href="' + _dealer.WebsiteUrl + '" target="_blank">Web</a>';
        }

        if (_dealer.FormGUID || _dealer.WebsiteUrl) { contentString += '</div>'; }


        contentString +=
            '</div>' +
            '</div>';

        var infowindow = new google.maps.InfoWindow({
            content: contentString,
        });

        $infowindows.push(infowindow);

        _marker.addListener('click', function () {
            $infowindows.forEach(function (x) {
                x.close();
            });

            infowindow.open(map, _marker);
        });

        google.maps.event.addListener(infowindow, 'domready', function () {
            // open form
            $('.js-mapBookBtn').on('click', function () {                
                formToOpen = document.getElementById('fad-form-' + $formGuid);
                var _dealer = $(formToOpen).find('.umbraco-forms-field.dealer input:hidden')[0];

                var dealerId = $(this)[0].getAttribute('data-dealerguid');
                var dealerName = $(this)[0].getAttribute('data-dealername');
                _dealer.value = dealerName + ' [' + dealerId + ']'; 
                formToOpen.style.display = 'block';
            });
        });

    }

    function mapSetCentre(_map) {
        var _location;
        if ($dealers.length > 0) {
            var dealer = $dealers[0];
            _location = { lat: parseFloat(dealer.Geolocation.Latitude), lng: parseFloat(dealer.Geolocation.Longitude) };

        }
        else {
            _location = { lat: -36.8426285, lng: 174.7675404 }; //Auckland
        }

        _map.setCenter(_location);
        _map.setZoom(12); //default zoom
    }

    function mapAdjustZoomandCentre(_map) {
        if ($dealers.length > 1) {
            var _latLngList = [];

            $dealers.forEach(function (x) {
                _latLngList.push(new google.maps.LatLng(parseFloat(x.Geolocation.Latitude), parseFloat(x.Geolocation.Longitude)));
            });

            var bounds = new google.maps.LatLngBounds();
            for (var i = 0, LtLgLen = _latLngList.length; i < LtLgLen; i++) {
                bounds.extend(_latLngList[i]);
            }

            _map.fitBounds(bounds); // auto-zoom
            //_map.panToBounds(bounds); // auto-center
        }
        else {
            mapSetCentre(_map);
        }
    }

    function mapRefresh() {
        mapCleanMarkers();
        mapAdjustZoomandCentre(map);
        mapAddMarkers();
    }

    function mapInit() {
        map = new google.maps.Map(document.getElementById('js-fad-map'), {
            disableDefaultUI: true,
            styles: [{ elementType: "geometry", stylers: [{ color: "#f5f5f5" }] },
                { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
                { elementType: "labels.text.fill", stylers: [{ color: "#616161" }] },
                { elementType: "labels.text.stroke", stylers: [{ color: "#f5f5f5" }] },
                { featureType: "administrative.land_parcel", elementType: "labels", stylers: [{ visibility: "off" }] },
                { featureType: "administrative.land_parcel", elementType: "labels.text.fill", stylers: [{ color: "#bdbdbd" }] },
                { featureType: "landscape", stylers: [{ color: "#dfe4e8" }] },
                { featureType: "landscape.natural", elementType: "labels", stylers: [{ color: "#757575" }, { visibility: "simplified" }, { weight: .5 }] },
                { featureType: "poi", elementType: "geometry", stylers: [{ color: "#eeeeee" }] },
                { featureType: "poi", elementType: "labels.text", stylers: [{ visibility: "off" }] },
                { featureType: "poi", elementType: "labels.text.fill", stylers: [{ color: "#757575" }] },
                { featureType: "poi.business", stylers: [{ visibility: "off" }] },
                { featureType: "poi.park", elementType: "geometry", stylers: [{ color: "#e5e5e5" }] },
                { featureType: "poi.park", elementType: "geometry.fill", stylers: [{ color: "#ade5a1" }] },
                { featureType: "poi.park", elementType: "labels", stylers: [{ visibility: "on" }] },
                { featureType: "poi.park", elementType: "labels.text.fill", stylers: [{ color: "#00662f" }] },
                { featureType: "poi.park", elementType: "labels.text.stroke", stylers: [{ visibility: "off" }] },
                { featureType: "road", elementType: "geometry", stylers: [{ color: "#ffffff" }] },
                { featureType: "road", elementType: "labels", stylers: [{ visibility: "on" }] },
                { featureType: "road", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
                { featureType: "road.arterial", elementType: "labels", stylers: [{ visibility: "on" }] },
                { featureType: "road.arterial", elementType: "labels.icon", stylers: [{ visibility: "on" }] },
                { featureType: "road.arterial", elementType: "labels.text.fill", stylers: [{ color: "#757575" }] },
                { featureType: "road.highway", elementType: "geometry", stylers: [{ color: "#dadada" }] },
                { featureType: "road.highway", elementType: "geometry.fill", stylers: [{ color: "#ffe856" }] },
                { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ visibility: "off" }] },
                { featureType: "road.highway", elementType: "labels", stylers: [{ visibility: "on" }] },
                { featureType: "road.highway", elementType: "labels.text.fill", stylers: [{ color: "#616161" }] },
                { featureType: "road.local", stylers: [{ visibility: "off" }] },
                { featureType: "road.local", elementType: "geometry", stylers: [{ color: "#ffffff" }, { visibility: "on" }, { weight: .5 }] },
                { featureType: "road.local", elementType: "labels", stylers: [{ visibility: "on" }] },
                { featureType: "road.local", elementType: "labels.text", stylers: [{ visibility: "on" }] },
                { featureType: "road.local", elementType: "labels.text.fill", stylers: [{ color: "#9e9e9e" }] },
                { featureType: "transit", stylers: [{ visibility: "off" }] },
                { featureType: "transit.line", elementType: "geometry", stylers: [{ color: "#e5e5e5" }] },
                { featureType: "transit.station", elementType: "geometry", stylers: [{ color: "#eeeeee" }] },
                { featureType: "water", elementType: "geometry", stylers: [{ color: "#4cc7f4" }] },
                { featureType: "water", elementType: "labels.text.fill", stylers: [{ color: "#0066a1" }] }]
        });

        mapSetCentre(map);      
    }
        
    return {
        init: function () {            

            if ($('.js-fad .step-1').length > 0) {                
                //console.log('fadbas init');

                $('.js-fad .step-1').on('change', '#chooseCity', function () {
                    $('.step-1')[0].style.display = 'none';
                    $('.step-2')[0].style.display = 'block';
                    $('#citySelector').val(this.value);

                    selectedCity = this.value;
                    selectedDealerType = $dealerList.getAttribute('data-dealertype');
                    updateTypeLinkClass();  
                    triggerDealerFilter();      
                    
                    mapUpdateDealers(selectedCity, selectedDealerType, $formGuid).then(function (data) {
                        $dealers = data;
                        mapInit();
                    }).catch(function (err) {
                        console.log(err);
                    });

                });

                $(document).on('click', '.js-dealerFilter a', function () {
                    selectedDealerType = $(this)[0].text;
                    updateTypeLinkClass();
                    loadDealerList(selectedCity, selectedDealerType, $formGuid);

                    mapUpdateDealers(selectedCity, selectedDealerType, $formGuid).then(function (data) {
                        $dealers = data;
                        mapRefresh();
                    }).catch(function (err) {
                        console.log(err);
                    });

                    //console.log(selectedDealerType + ' was clicked');
                    dataLayer.push({
                        'event': 'requiredService',
                        'service': selectedDealerType
                    });

                });

                $('.js-fad .step-2').on('change', '#citySelector', function () {
                    selectedCity = this.value;
                    loadDealerList(selectedCity, selectedDealerType, $formGuid);

                    mapUpdateDealers(selectedCity, selectedDealerType, $formGuid).then(function (data) {
                        $dealers = data;
                        mapRefresh();
                    }).catch(function (err) {
                        console.log(err);
                    });

                });

                $('.js-fad .step-2').on('change', '#toggleShowMap', function () {
                    if ($(this).is(':checked')) {
                        if (isNoResult) {
                            $mapGrayout[0].style.display = 'block';
                        }
                        $fadMap.style.display = 'block';
                        $fadList.style.display = 'none';
                        mapRefresh();
                    }
                    else {
                        $mapGrayout[0].style.display = 'none';
                        $fadMap.style.display = 'none';
                        $fadList.style.display = 'grid';
                    }
                });

                // open the book form
                $('#dealer-cards').on('click', '.js-bookBtn', function () {
                    formToOpen = document.getElementById('fad-form-' + $formGuid);
                    var _dealer = $(formToOpen).find('.umbraco-forms-field.dealer input:hidden')[0];

                    var dealerId = $(this)[0].getAttribute('data-dealerguid');
                    var dealerName = $(this)[0].getAttribute('data-dealername');
                    _dealer.value = dealerName + ' [' + dealerId + ']';
                    formToOpen.style.display = 'block';
                });

                // close the form
                $('.fad-form-modal').on('click', '.close', function () {
                    formToOpen.style.display = "none";
                });

                // When the user clicks anywhere outside of the modal, close it
                window.onclick = function (event) {
                    if (formToOpen !== null && formToOpen !== "") {
                        if (event.target == formToOpen) {
                            formToOpen.style.display = 'none';
                        }
                    }
                };

            }
          
        }, 
        mapLoaded: function () {
            //console.log('fadbas map loaded');
        }
    };
}());

VOLKSWAGEN.FindDealer.init();



VOLKSWAGEN.TextareaAutoResize = (function () {

    return {
        init: function () {
            $('.uf-textarea-control').autoResize({extraSpace:0, limit: 5000});
        }
    };
}());

VOLKSWAGEN.TextareaAutoResize.init();


VOLKSWAGEN.ServicePlan = (function () {
    var $submitBtn = $('.js-serviceplan-submit');
    var $carModelsObj = '';
    var $carModelsArr = [];
    var $carId = 0;
    var $currentSelectedModel = null;

    function loadAllData() {
        var _url = '/app/nz/api/serviceplan/getall';
        $.ajax({
            type: 'POST',
            url: _url,
            success: function (data) {
                //console.log(data);
                $carModelsObj = data.reduce((r, a) => {
                    r[a.Type] = [...r[a.Type] || [], a];
                    return r;
                }, {});

            },
            error: function (response) {
                console.log(response);
            }
        });        
    }

    function updateCarModelsDropdown(_selectedCarType) {
        var $carModelDropdown = document.getElementById('sp-carModelSelector');

        document.querySelectorAll('#sp-carModelSelector option').forEach(option => option.remove());
        var option = document.createElement("option");
        option.text = 'Select Car Model';
        option.value = '';
        $carModelDropdown.add(option);

        $carModelsArr = $carModelsObj[_selectedCarType];
        $carModelsArr.forEach(function (e) {
            var option = document.createElement("option");
            option.text = e.DisplayName;
            option.value = e.Id;
            $carModelDropdown.add(option);
        });
    }

    function displayResult(_nodeId, _carId) {
        var _url = '/app/nz/api/serviceplan/result';
        $.ajax({
            type: 'GET',
            url: _url,
            data: { "nodeId": _nodeId, "carId": _carId },
            success: function (response) {
                $('#vehicleServicePlan').html(response);
            },
            error: function (response) {
                console.log(response);
            }
        });
    }

    return {
        init: function () {
            var $serviceplanBtn = $('.js-serviceplan-btn');
            var $spform = $('.vehicle-selector-form-modal');

            if ($spform.length < 1) { return false; }

            $submitBtn[0].disabled = true;
            loadAllData();

            $($serviceplanBtn).on('click', function () {
                $spform[0].style.display = 'block';
            });

            $($spform).on('click', '.close', function () {
                $spform[0].style.display = 'none';
            });

            $($spform).on('change', '#sp-carTypeSelector', function () {
                var _val = $(this).val();
                if (_val != '') {
                    updateCarModelsDropdown(_val);
                    $submitBtn[0].disabled = true;
                }
            });

            $($spform).on('change', '#sp-carModelSelector', function () {
                if ($(this).val() != '') {
                    $submitBtn[0].disabled = false;
                    $carId = $(this).val();
                }
                else {
                    $submitBtn[0].disabled = true;
                }
            });

            $($spform).on('click', '.js-serviceplan-submit', function () {
                $currentSelectedModel = $carModelsArr.find(element => element.Id == $carId);
                var _nodeId = $spform[0].getAttribute('data-nodeid');
                displayResult(_nodeId, $carId);

                $serviceplanBtn[0].style.display = 'none';
                $spform[0].style.display = 'none';
            });

            $('#vehicleServicePlan').on('click', '.js-sp-changeVehicleBtn', function () {
                if ($currentSelectedModel === undefined) {
                    return;
                }
                $spform[0].style.display = 'block';
            });

        }
    };
}());

VOLKSWAGEN.ServicePlan.init();



VOLKSWAGEN.FormSpinner = (function () {

    return {
        init: function () {
            $('.umbraco-forms-form').on('submit', 'form', function () {
                var spinner = $('.forms-submit-row', this).find('.StyledSpinner');
                var button = $('.forms-submit-row', this).find('.StyledSubmitButton');

                button.fadeOut(400, function () { spinner.fadeIn(400); });
            });
        }
    };
}());

VOLKSWAGEN.FormSpinner.init();


VOLKSWAGEN.ServiceCost = (function () {    
    var $formSubmitBtn = $('.js-scform-submit');

    var $vehicleSelectorPanel = null;
    var $vehicleDetailsPanel = null;
    var $vehicleSelectorSubmitBtn = null;

    var allData = [];
    var objects = {
        CarType: {
            name: 'Type',
            selectedValue: '',
            options: [],
            filteredData: []
        },
        CarModel: {
            name: 'Model',
            selectedValue: '',
            options: [],
            filteredData: []
        },
        Year: {
            name: 'Year',
            selectedValue: '',
            options: [],
            filteredData: []
        },
        Engine: {
            name: 'Engine',
            selectedValue: '',
            options: [],
            filteredData: []
        },
        Transmission: {
            name: 'Transmission',
            selectedValue: '',
            options: [],
            filteredData: []
        }
    };

    var formData = new Object();

    function loadAllData() {
        return new Promise(function (resolve, reject) {
            var _url = '/app/nz/api/servicecost/getall';
            $.ajax({
                type: 'GET',
                url: _url,
                success: function (data) {
                    resolve(data);
                },
                error: function (err) {
                    reject(err);
                }
            });
        });        
    }

    function groupBy(xs, key) {
        return xs.reduce(function (rv, x) {
            (rv[x[key]] = rv[x[key]] || []).push(x);
            return rv;
        }, {});
    };

    function customFilter(_item, _next) {
        var _data = _item.filteredData,
            key1 = _item.name,
            key2 = _next.name,
            selectedVal = _item.selectedValue;

        var dts = [];
        dts = _data.filter(function (obj) {
            return (obj[key1] === selectedVal);
        });
        _next.filteredData = dts;

        var groupedObj = groupBy(dts, key2);
        _next.options = Object.keys(groupedObj);
    }

    function customReset(_arr) {
        _arr.forEach(function (key) {
            objects[key].selectedValue = '';
            objects[key].options = '';
            objects[key].filteredData = '';
        })
    }

    function initLoadCarTypeOptions(_data, _key) {
        var groupedObj = groupBy(_data, _key);
        return Object.keys(groupedObj);
    }

    function initCarTypeDropdown() {
        var $carTypeDropdown = document.getElementById('sc-carType');

        document.querySelectorAll('#sc-carType option').forEach(option => option.remove());
        var option = document.createElement("option");
        option.text = 'Car Type';
        option.value = '';
        $carTypeDropdown.add(option);

        objects.CarType.options.forEach(function (e) {
            var option = document.createElement("option");
            option.text = e;
            option.value = e;
            $carTypeDropdown.add(option);
        });
    }

    function disableButton(_btn) {
        _btn.closest('.StyledCartileButtonsContainer').style.cursor = 'not-allowed';
        _btn.style.pointerEvents = 'none';
    }

    function enableButton(_btn) {
        _btn.closest('.StyledCartileButtonsContainer').style.cursor = 'pointer';
        _btn.style.pointerEvents = 'auto';
    }

    function collectFormData() {
        var _nodeId = $('.js-servicecost')[0].getAttribute('data-nodeid');
        formData.nodeId = _nodeId; 
        formData.carType = objects.CarType.selectedValue;
        formData.carModel = objects.CarModel.selectedValue;
        formData.modelYear = objects.Year.selectedValue;
        formData.engineType = objects.Engine.selectedValue;
        formData.transmission = objects.Transmission.selectedValue;       
        //console.log(formData);
        return formData;
    }

    function loadSCResult() {
        var _url = '/app/nz/api/servicecost/result';
        var _model = collectFormData();
        $.ajax({
            type: 'POST',
            url: _url,
            data: _model,
            success: function (data) {
                $('#servicecost-result').html(data);
                $vehicleSelectorPanel = $('#vehicleSelectorPanel');
                $vehicleDetailsPanel = $('#vehicleDetailsPanel');
                $vehicleSelectorSubmitBtn = $('.js-scv-submit');
            },
            error: function (response) {
                console.log(response);
            }
        });
    }

    return {
        init: function () {
            var $scForm = $('.js-scform');
            var $scResult = $('#servicecost-result');

            if ($scForm.length < 1) { return false; }

            loadAllData().then(function (data) {
                allData = data;
                objects.CarType.filteredData = data;
                objects.CarType.options = initLoadCarTypeOptions(allData, objects.CarType.name);
                initCarTypeDropdown();
            });

            $($scForm).on('change', '#sc-carType', function () {
                //console.log('selected TYPE: ' +$(this).val());
                var _val = $(this).val();
                if (_val != '') {
                    objects.CarType.selectedValue = _val;
                    customFilter(objects.CarType, objects.CarModel);
                    updateDropdown('sc-carModel', 'Car Model', objects.CarModel.options, false);

                    if (objects.CarModel.options.length == 1) {
                        objects.CarModel.selectedValue = objects.CarModel.options[0];
                        customFilter(objects.CarModel, objects.Year);
                        updateDropdown('sc-modelYear', 'Year', objects.Year.options, false);
                    }
                    else {
                        objects.CarModel.selectedValue = '';
                        customReset(['Year', 'Engine', 'Transmission']);
                        //reset rest of dropdowns
                        updateDropdown('sc-modelYear', 'Model Year', ['Model Year'], true);
                        updateDropdown('sc-engineType', 'Engine Type', ['Engine Type'], true);
                        updateDropdown('sc-transmission', 'Transmission', ['Transmission'], true);
                        disableButton($formSubmitBtn[0]);
                    }
                }
            });

            $($scForm).on('change', '#sc-carModel', function () {
                //console.log('selected MODEL: ' +$(this).val());
                var _val = $(this).val();
                if (_val != '') {
                    objects.CarModel.selectedValue = _val;
                    customFilter(objects.CarModel, objects.Year);
                    updateDropdown('sc-modelYear', 'Model Year', objects.Year.options, false);

                    if (objects.Year.options.length == 1) {
                        objects.Year.selectedValue = objects.Year.options[0];
                        customFilter(objects.Year, objects.Engine);
                        updateDropdown('sc-engineType', 'Engine', objects.Engine.options, false);

                        if (objects.Engine.options.length == 1) {
                            objects.Engine.selectedValue = objects.Engine.options[0];
                            customFilter(objects.Engine, objects.Transmission);
                            updateDropdown('sc-transmission', 'Transmission', objects.Transmission.options, false);

                            if (objects.Transmission.options.length == 1) {
                                objects.Transmission.selectedValue = objects.Transmission.options[0];
                                enableButton($formSubmitBtn[0]);
                            }
                            else {
                                disableButton($formSubmitBtn[0]);
                            }
                        }

                    }
                    else {
                        objects.Year.selectedValue = '';
                        customReset(['Engine', 'Transmission']);
                        //reset rest of dropdowns
                        updateDropdown('sc-engineType', 'Engine Type', ['Engine Type'], true);
                        updateDropdown('sc-transmission', 'Transmission', ['Transmission'], true);
                        disableButton($formSubmitBtn[0]);
                    }
                }
            });

            $($scForm).on('change', '#sc-modelYear', function () {
                //console.log('selected YEAR: ' +$(this).val());
                var _val = $(this).val();
                if (_val != '') {
                    objects.Year.selectedValue = _val;
                    customFilter(objects.Year, objects.Engine);
                    updateDropdown('sc-engineType', 'Engine Type', objects.Engine.options, false);

                    if (objects.Engine.options.length == 1) {
                        objects.Engine.selectedValue = objects.Engine.options[0];
                        customFilter(objects.Engine, objects.Transmission);
                        updateDropdown('sc-transmission', 'Transmission', objects.Transmission.options, false);

                        if (objects.Transmission.options.length == 1) {
                            objects.Transmission.selectedValue = objects.Transmission.options[0];
                            enableButton($formSubmitBtn[0]);
                        }
                        else {
                            disableButton($formSubmitBtn[0]);
                        }
                    }
                    else {
                        objects.Engine.selectedValue = '';
                        customReset(['Transmission']);
                        //reset rest of dropdowns
                        updateDropdown('sc-transmission', 'Transmission', ['Transmission'], true);
                        disableButton($formSubmitBtn[0]);
                    }
                }
            });

            $($scForm).on('change', '#sc-engineType', function () {
                //console.log('selected ENGINE: ' +$(this).val());
                var _val = $(this).val();
                if (_val != '') {
                    objects.Engine.selectedValue = _val;
                    customFilter(objects.Engine, objects.Transmission);

                    updateDropdown('sc-transmission', 'Transmission', objects.Transmission.options, false);

                    if (objects.Transmission.options.length == 1) {
                        objects.Transmission.selectedValue = objects.Transmission.options[0];
                        enableButton($formSubmitBtn[0]);
                    }
                    else {
                        objects.Transmission.selectedValue = '';
                        disableButton($formSubmitBtn[0]);
                    }

                }
            });

            $($scForm).on('change', '#sc-transmission', function () {
                //console.log('selected TRANSMISSION: ' +$(this).val());
                var _val = $(this).val();
                if (_val != '') {
                    objects.Transmission.selectedValue = _val;
                    enableButton($formSubmitBtn[0]);
                }
                else {
                    disableButton($formSubmitBtn[0]);
                }
            });

            $($scForm).on('click', '.js-scform-submit', function () {
                $('.js-servicecost .step-1')[0].style.display = 'none';
                $('.js-servicecost .step-2')[0].style.display = 'block';
                loadSCResult();               
            });


            $($scResult).on('click', '.js-sc-changeVehicleBtn', function () {

                if ($vehicleSelectorPanel[0].style.display == 'none') {
                    $vehicleSelectorPanel[0].style.display = 'block';
                    $vehicleDetailsPanel.addClass('obscured');

                    //prepopulate select options 
                    updateDropdown('scv-carType', 'Car Type', objects.CarType.options, false);
                    document.getElementById('scv-carType').value = formData.carType;

                    updateDropdown('scv-carModel', 'Car Model', objects.CarModel.options, false);
                    document.getElementById('scv-carModel').value = formData.carModel;

                    updateDropdown('scv-modelYear', 'Model Year', objects.Year.options, false);
                    document.getElementById('scv-modelYear').value = formData.modelYear;

                    updateDropdown('scv-engineType', 'Engine Type', objects.Engine.options, false);
                    document.getElementById('scv-engineType').value = formData.engineType;

                    updateDropdown('scv-transmission', 'Transmission', objects.Transmission.options, false);
                    document.getElementById('scv-transmission').value = formData.transmission;             
                }
                else {
                    $vehicleSelectorPanel[0].style.display = 'none';
                    $vehicleDetailsPanel.removeClass('obscured');
                }             
            });

            $($scResult).on('change', '#scv-carType', function () {
                //console.log('2)selected TYPE: ' + $(this).val());
                var _val = $(this).val();
                if (_val != '') {
                    objects.CarType.selectedValue = _val;
                    customFilter(objects.CarType, objects.CarModel);
                    updateDropdown('scv-carModel', 'Car Model', objects.CarModel.options, false);

                    if (objects.CarModel.options.length == 1) {
                        objects.CarModel.selectedValue = objects.CarModel.options[0];
                    }
                    else {
                        objects.CarModel.selectedValue = '';
                        customReset(['Year', 'Engine', 'Transmission']);
                        //reset rest of dropdowns
                        updateDropdown('scv-modelYear', 'Model Year', ['Model Year'], true);
                        updateDropdown('scv-engineType', 'Engine Type', ['Engine Type'], true);
                        updateDropdown('scv-transmission', 'Transmission', ['Transmission'], true);
                        disableButton($vehicleSelectorSubmitBtn[0]);
                    }
                }
            });

            $($scResult).on('change', '#scv-carModel', function () {
                //console.log('2)selected MODEL: ' + $(this).val());
                var _val = $(this).val();
                if (_val != '') {
                    objects.CarModel.selectedValue = _val;
                    customFilter(objects.CarModel, objects.Year);
                    updateDropdown('scv-modelYear', 'Model Year', objects.Year.options, false);

                    if (objects.Year.options.length == 1) {
                        objects.Year.selectedValue = objects.Year.options[0];
                        customFilter(objects.Year, objects.Engine);
                        updateDropdown('scv-engineType', 'Engine', objects.Engine.options, false);

                        if (objects.Engine.options.length == 1) {
                            objects.Engine.selectedValue = objects.Engine.options[0];
                            customFilter(objects.Engine, objects.Transmission);
                            updateDropdown('scv-transmission', 'Transmission', objects.Transmission.options, false);

                            if (objects.Transmission.options.length == 1) {
                                objects.Transmission.selectedValue = objects.Transmission.options[0];
                                enableButton($vehicleSelectorSubmitBtn[0]);
                            }
                            else {
                                disableButton($vehicleSelectorSubmitBtn[0]);
                            }
                        }
                    }
                    else {
                        objects.Year.selectedValue = '';
                        customReset(['Engine', 'Transmission']);
                        //reset rest of dropdowns
                        updateDropdown('scv-engineType', 'Engine Type', ['Engine Type'], true);
                        updateDropdown('scv-transmission', 'Transmission', ['Transmission'], true);
                        disableButton($vehicleSelectorSubmitBtn[0]);
                    }
                }
            });

            $($scResult).on('change', '#scv-modelYear', function () {
                //console.log('2)selected YEAR: ' + $(this).val());
                var _val = $(this).val();
                if (_val != '') {
                    objects.Year.selectedValue = _val;
                    customFilter(objects.Year, objects.Engine);
                    updateDropdown('scv-engineType', 'Engine Type', objects.Engine.options, false);

                    if (objects.Engine.options.length == 1) {
                        objects.Engine.selectedValue = objects.Engine.options[0];
                        customFilter(objects.Engine, objects.Transmission);
                        updateDropdown('scv-transmission', 'Transmission', objects.Transmission.options, false);

                        if (objects.Transmission.options.length == 1) {
                            objects.Transmission.selectedValue = objects.Transmission.options[0];
                            enableButton($vehicleSelectorSubmitBtn[0]);
                        }
                        else {
                            disableButton($vehicleSelectorSubmitBtn[0]);
                        }
                    }
                    else {
                        objects.Engine.selectedValue = '';
                        customReset(['Transmission']);
                        //reset rest of dropdowns
                        updateDropdown('scv-transmission', 'Transmission', ['Transmission'], true);
                        disableButton($vehicleSelectorSubmitBtn[0]);
                    }
                }
            });

            $($scResult).on('change', '#scv-engineType', function () {
                //console.log('2)selected ENGINE: ' + $(this).val());
                var _val = $(this).val();
                if (_val != '') {
                    objects.Engine.selectedValue = _val;
                    customFilter(objects.Engine, objects.Transmission);

                    updateDropdown('scv-transmission', 'Transmission', objects.Transmission.options, false);

                    if (objects.Transmission.options.length == 1) {
                        objects.Transmission.selectedValue = objects.Transmission.options[0];
                        enableButton($vehicleSelectorSubmitBtn[0]);
                    }
                    else {
                        objects.Transmission.selectedValue = '';
                        disableButton($vehicleSelectorSubmitBtn[0]);
                    }

                }
            });

            $($scResult).on('change', '#scv-transmission', function () {
                //console.log('2)selected TRANSMISSION: ' + $(this).val());
                var _val = $(this).val();
                if (_val != '') {
                    objects.Transmission.selectedValue = _val;
                    enableButton($vehicleSelectorSubmitBtn[0]);
                }
                else {
                    disableButton($vehicleSelectorSubmitBtn[0]);
                }
            });

            $($scResult).on('click', '.js-scv-submit', function () {
                $vehicleSelectorPanel[0].style.display = 'none';

                if (formData.carType === objects.CarType.selectedValue && formData.carModel === objects.CarModel.selectedValue && formData.modelYear === objects.Year.selectedValue
                    && formData.engineType === objects.Engine.selectedValue && formData.transmission === objects.Transmission.selectedValue) {

                }
                else {
                    loadSCResult(); 
                }
                
            });

        }
    };
}());

VOLKSWAGEN.ServiceCost.init();


VOLKSWAGEN.Finance = (function () {
    var $landing = $('.finance-landing');
    var $financeResult = $('#finance-result');
    var $financeQuoteForm = $('#financeQuote');
    var $vehicleSelectorForm = $('#finance-vehicleSelector');
    var $nextbtn = $('.js-fc-vs-next');
    var $nodeId = $landing.attr('data-nodeid');

    var allData = [];
    var finObjects = {
        VehicleType: {
            name: 'ModelCategory',
            selectedValue: '',
            options: [],
            filteredData: []
        },
        CarModel: {
            name: 'ModelFamily',
            selectedValue: '',
            options: [],
            filteredData: []
        },
        Engine: {
            name: 'ModelVariant',
            selectedValue: '',
            options: [],
            filteredData: []
        },
    };

    function initFinance() {

        var _financeUrl = $landing[0].getAttribute('data-fcbaseurl');

        //solve cross-origin issue
        window.addEventListener('message', function (event) {
            // IMPORTANT: Check the origin of the data!
            if (~event.origin.indexOf(_financeUrl)) {
                if (event.data.toString().indexOf('openSelectVehicleForm') > -1 ||
                    event.data.toString().indexOf('popupBox') > -1) {
                    eval(event.data);
                } else if (event.data.toString().indexOf('resizeIframe') > -1) {
                    //no need to resize iframe but have to handle it here
                }
                else {
                    openFinanceQuoteForm(event.data);
                }
            }

            if (~event.origin.indexOf('vwplatform.localhost')) { 
                if (event.data.toString().indexOf('openSelectVehicleForm') > -1 || event.data.toString().indexOf('popupBox') > -1) {
                    eval(event.data);
                } else {
                   
                }
            }
        });
    }

    function popupBox() {
        $('.finance-page').slideDown();
        $('body').css('overflow', 'hidden');
    }

    function openSelectVehicleForm() {
        $vehicleSelectorForm[0].style.display = 'block';
        $nextbtn.addClass('inactiveLink');

        updateFinDropdown('fc-vehicleType', 'Vehicle Type', finObjects.VehicleType.options);
        updateFinDropdown('fc-carModel', 'Car Model', []);
        updateFinDropdown('fc-engineType', 'Variant', []);
        finReset(['CarModel', 'Engine']);
    }

    function openFinanceQuoteForm(model) {
        //put JSON model into the attribute
        $('.btnFinanceQuote').attr('model', JSON.stringify(model));
        $financeQuoteForm[0].style.display = 'block';
        updateFormHiddenFields($financeQuoteForm);
        console.log(model);
    }



    function updateFormHiddenFields(_form) {
        var financeData = JSON.parse($('.btnFinanceQuote')[0].getAttribute('model'));
        var _note = null;
        if (financeData.buy_section == true) {
            _note = "CREDIT term: " + financeData.buy_term + ", deposit: $" + financeData.buy_deposit + ", final balloon: $" + financeData.buy_balloon;
        }
        else {
            _note = "BUSINESS LEASE term: " + financeData.lease_term + ", advance rental: $" + financeData.lease_rental + ", residual value: $" + financeData.lease_residual;
        }

        if (!!financeData.autoplay_id) {
            _note = _note + ", autoplay id: " + financeData.autoplay_id + ", autoplay registration number: " + financeData.modelPlate;
        }

        var carModel = _form.find('.umbraco-forms-field.carmodel input:hidden')[0];
        carModel.value = financeData.modelFamily;

        var modelVariant = _form.find('.umbraco-forms-field.modelvariant input:hidden')[0];
        modelVariant.value = financeData.modelVariant;

        var details = _form.find('.umbraco-forms-field.findetails input:hidden')[0];        
        details.value = _note;
    }


    function loadAllFinData() {
        return new Promise(function (resolve, reject) {
            var _url = '/app/nz/api/finance/getall';
            $.ajax({
                type: 'GET',
                url: _url,
                success: function (data) {
                    resolve(data);
                },
                error: function (err) {
                    reject(err);
                }
            });
        });
    }

    function groupBy(xs, key) {
        return xs.reduce(function (rv, x) {
            (rv[x[key]] = rv[x[key]] || []).push(x);
            return rv;
        }, {});
    };

    function finFilter(_item, _next) {
        var _data = _item.filteredData,
            key1 = _item.name,
            key2 = _next.name,
            selectedVal = _item.selectedValue;

        var dts = [];
        dts = _data.filter(function (obj) {
            return (obj[key1] === selectedVal);
        });
        _next.filteredData = dts;

        var groupedObj = groupBy(dts, key2);
        _next.options = Object.keys(groupedObj);
    }

    function finReset(_arr) {
        _arr.forEach(function (key) {
            finObjects[key].selectedValue = '';
            finObjects[key].options = '';
            finObjects[key].filteredData = '';
        })
    }

    function updateFinDropdown(_dropdownElementId, _firstOptionText, _optionsArr) {
        var $dropdown = document.getElementById(_dropdownElementId);
        document.querySelectorAll('#' + _dropdownElementId + ' option').forEach(option => option.remove());

        var option = document.createElement("option");
        option.text = _firstOptionText;
        option.value = '';
        $dropdown.add(option);

        if (_optionsArr.length > 0) {
            _optionsArr.forEach(function (e) {
                var option = document.createElement("option");
                option.text = e;
                option.value = e;
                $dropdown.add(option);
            });
        }
        
        $dropdown.style.display = 'inline-block';
    }

    function loadFinResult(_nodeId, _code) {
        var _url = '/app/nz/api/finance/result';
        $.ajax({
            type: 'GET',
            url: _url,
            data: { "nodeId": _nodeId, "code": _code},
            success: function (data) {
                $('#finance-result').html(data);
            },
            error: function (response) {
                console.log(response);
            }
        });
    }

    function loadStockFinResult(_nodeId, _listingSeq) {
        var _url = '/app/nz/api/finance/result';
        $.ajax({
            type: 'GET',
            url: _url,
            data: { "nodeId": _nodeId, "code": null, "listingSeq": _listingSeq },
            success: function (data) {
                $('#finance-result').html(data);
            },
            error: function (response) {
                console.log(response);
            }
        });
    }

    function validateFinCode(_modelCode) {       
        return new Promise(function (resolve, reject) {
            var _url = '/app/nz/api/finance/validate';
            $.ajax({
                type: 'GET',
                url: _url,
                data: { "code": _modelCode },
                success: function (data) {
                    resolve(data);
                },
                error: function (err) {
                    reject(err);
                }
            });
        });
    }


    return {
        init: function () {            
            if ($landing.length < 1) { return false; }            
            initFinance();

            loadAllFinData().then(function (data) {
                allData = data;
                finObjects.VehicleType.filteredData = data;
                finObjects.VehicleType.options = Object.keys(groupBy(allData, finObjects.VehicleType.name));
                updateFinDropdown('fl-vehicleType', 'Vehicle Type', finObjects.VehicleType.options);
            });

            var _modelCode = getURLParameter('modelcode');
            var _listingSeq = getURLParameter('listingSeq');
            if (!!_modelCode) {
                validateFinCode(_modelCode).then(function (data) {
                    if (data === "True") {
                        $landing[0].style.display = 'none';
                        loadFinResult($nodeId, _modelCode);
                    }
                    else {

                    }
                });
            }
            else if (!!_listingSeq) {
                $landing[0].style.display = 'none';
                loadStockFinResult($nodeId, _listingSeq);
            }

            $($landing).on('change', '#fl-vehicleType', function () {
                var _val = $(this).val();
                $('#fl-engineType')[0].style.display = 'none';

                if (_val != '') {
                    finObjects.VehicleType.selectedValue = _val;
                    finFilter(finObjects.VehicleType, finObjects.CarModel);
                    updateFinDropdown('fl-carModel', 'Car Model', finObjects.CarModel.options);               
                    finReset(['Engine']);
                }
                else {
                    $('#fl-carModel')[0].style.display = 'none';
                }                
            });

            $($landing).on('change', '#fl-carModel', function () {
                var _val = $(this).val();
                if (_val != '') {
                    finObjects.CarModel.selectedValue = _val;
                    finFilter(finObjects.CarModel, finObjects.Engine);
                    updateFinDropdown('fl-engineType', 'Variant', finObjects.Engine.options);
                }
                else {
                    $('#fl-engineType')[0].style.display = 'none';
                }
            });

            $($landing).on('change', '#fl-engineType', function () {
                var _val = $(this).val();
                if (_val != '') {
                    finObjects.Engine.selectedValue = _val;

                    $('#fl-submit')[0].style.display = 'flex';
                }
            }); 

            $($landing).on('click', '#fl-submit', function () {
                $landing[0].style.display = 'none';

                var _target = finObjects.Engine.filteredData.find(x => x.ModelVariant === finObjects.Engine.selectedValue);

                loadFinResult($nodeId, _target.ModelCode);                    
            });

            $($vehicleSelectorForm).on('click', '.close', function () {
                $vehicleSelectorForm[0].style.display = "none";
            });

            $($vehicleSelectorForm).on('click', '.js-fc-vs-next', function () {
                if (finObjects.Engine.selectedValue === '') {
                    return;
                }
                var _target = finObjects.Engine.filteredData.find(x => x.ModelVariant === finObjects.Engine.selectedValue);
                loadFinResult($nodeId, _target.ModelCode);
                $vehicleSelectorForm[0].style.display = "none";
            });

            $($vehicleSelectorForm).on('change', '#fc-vehicleType', function () {
                var _val = $(this).val();
                if (_val != '') {
                    finObjects.VehicleType.selectedValue = _val;
                    finFilter(finObjects.VehicleType, finObjects.CarModel);
                    updateFinDropdown('fc-carModel', 'Car Model', finObjects.CarModel.options);
                    finReset(['Engine']);
                }
                else {
                    updateFinDropdown('fc-carModel', 'Car Model', ['Car Model']);
                    updateFinDropdown('fc-engineType', 'Variant', ['Variant']);
                }
                $nextbtn.addClass('inactiveLink');
            });

            $($vehicleSelectorForm).on('change', '#fc-carModel', function () {
                var _val = $(this).val();
                if (_val != '') {
                    finObjects.CarModel.selectedValue = _val;
                    finFilter(finObjects.CarModel, finObjects.Engine);
                    updateFinDropdown('fc-engineType', 'Variant', finObjects.Engine.options);
                }
                else {
                    updateDropdown('fc-engineType', 'Variant', ['Variant']);
                }
                $nextbtn.addClass('inactiveLink');
            });

            $($vehicleSelectorForm).on('change', '#fc-engineType', function () {
                var _val = $(this).val();
                if (_val != '') {
                    finObjects.Engine.selectedValue = _val;
                    $nextbtn.removeClass('inactiveLink');
                }
                else {
                    finObjects.Engine.selectedValue = '';
                    $nextbtn.addClass('inactiveLink');
                }
            });


            $($financeQuoteForm).on('click', '.close', function () {
                $financeQuoteForm[0].style.display = "none";
            });
            
        }
    };

})();

VOLKSWAGEN.Finance.init();


VOLKSWAGEN.ExtenedWarranty = (function () {
    var $validateRegoBtn = $('#js-validateWarrantyRego');
    var $submitBtn = null;
    var $agreementform = $('.ew-agreement-form-modal');

    function validateRego() {
        var $warrantyRego = $('#warrantyRego');
        var _rego = $warrantyRego.val();
        if (typeof (_rego) == 'undefined' || _rego == null || _rego == '') {
            console.log('Required Rego');
            return;
        }

        _rego = _rego.replace(/\s+/g, '');
        var $regoErrorMsg = $('.js-validateRego-error-msg')[0];
        var $regoSuccessMsg = $('.js-validateRego-success-msg')[0];

        var _url = '/app/nz/api/warranty/validate?rego=' + _rego;
        $.ajax({
            type: 'POST',
            url: _url,
            success: function (response) {
                console.log(response);
                if (response.ExtendedWarrantyEligible) {
                    $warrantyRego[0].readOnly = true;
                    collectWarrantyData(response);

                    var _msgTxt = $regoSuccessMsg.innerText.replace("{carModel}", response.VehicleModel)
                        .replace("{expiryDate}", response.WarrantyEndDate);
                    $regoSuccessMsg.innerText = _msgTxt;
                    $regoSuccessMsg.style.display = "block";
                    $regoErrorMsg.style.display = "none";
                    $validateRegoBtn[0].style.display = "none";
                    
                    $agreementform[0].style.display = 'block';
                }
                else {
                    $regoErrorMsg.style.display = "block";
                }
            },
            error: function (response) {
                console.log(response);
            }
        });
    }

    function collectWarrantyData(_resp) {
        var _carmodel = $('.umbraco-forms-field.carmodel input:hidden')[0];
        _carmodel.value = _resp.VehicleModel;

        var _warrantyEndDate = $('.umbraco-forms-field.warrantyenddate input:hidden')[0];
        _warrantyEndDate.value = _resp.WarrantyEndDate;

        var _vin = $('.umbraco-forms-field.vin input:hidden')[0];
        _vin.value = _resp.VIN;

        var _initialDeliveryDate = $('.umbraco-forms-field.initialdeliverydate input:hidden')[0];
        _initialDeliveryDate.value = _resp.InitialDeliveryDate;

        var _contractStartDate = $('.umbraco-forms-field.contactstartdate input:hidden')[0];
        _contractStartDate.value = _resp.ContractStartDate;

        var _contractEndDate = $('.umbraco-forms-field.contactenddate input:hidden')[0];
        _contractEndDate.value = _resp.ContractEndDate;

        var _price = $('.umbraco-forms-field.price input:hidden')[0];
        _price.value = $('#extendWarrantyCost').val();
    }

    function getCustomerDetails(code) {
        var _companyName = $('.umbraco-forms-field.companyname input:text')[0];
        var _firstName = $('.umbraco-forms-field.firstname input:text')[0];
        var _lastName = $('.umbraco-forms-field.lastname input:text')[0];
        var _email = $('.umbraco-forms-field.email input:text')[0];
        var _mobile = $('.umbraco-forms-field.mobile input:text')[0];

        var _address = $('.umbraco-forms-field.address input:text')[0];
        var _suburb = $('.umbraco-forms-field.suburb input:text')[0];
        var _city = $('.umbraco-forms-field.city input:text')[0];
        var _postcode = $('.umbraco-forms-field.postcode input:text')[0];

        var _url = '/app/nz/api/owners/getdetails?code=' + code;
        $.ajax({
            type: 'POST',
            url: _url,
            success: function (response) {
                console.log(response);
                _companyName.value = response.CompanyName;
                _firstName.value = response.FirstName;
                _lastName.value = response.LastName;
                _email.value = response.Email;
                _mobile.value = response.Mobile;
                _address.value = response.Address1;
                _suburb.value = response.Suburb;
                _city.value = response.City;
                _postcode.value = response.Postcode;
            },
            error: function (response) {
                console.log(response);
            }
        });

    }

    return {
        init: function () {

            var $form = $('#extendedWarranty');
            if (!$form.length) { return false; }

            var _clientCode = getURLParameter('code');
            if (!!_clientCode) {
                getCustomerDetails(_clientCode);
            }

            $validateRegoBtn.on('click', function () {
                validateRego();
            });

            $submitBtn = $($form).find('.vw-formsubmit-button')[0];
            if ($submitBtn != null) {
                $submitBtn.closest('.forms-submit-row').style.cursor = 'not-allowed';
                $submitBtn.style.pointerEvents = 'none';
            }
            
            $('.js-agree-btn').on('click', function () {
                $agreementform[0].style.display = 'none';
                $submitBtn.closest('.forms-submit-row').style.cursor = 'pointerd';
                $submitBtn.style.pointerEvents = 'auto';
            });

        }
    };
}());

VOLKSWAGEN.ExtenedWarranty.init();


VOLKSWAGEN.StockSearch = (function () {
    var $sidebar = $('.js-stock-sidebar');
    var $typeOfStockPage = $('.js-stock-type').attr('data-stocktype');
    var $filterResetBtn = $('.js-reset-filter');
    var $sliderPrice = document.getElementById('price-range');
    var $sliderPriceLabel = $('.c-stock-filter__group-pricelabel');
    var $sliderYear = document.getElementById('year-range');
    var $sliderYearLabel = $('.c-stock-filter__group-yearlabel');
    var $sliderMilage = document.getElementById('mileage-range');
    var $sliderMileageLabel = $('.c-stock-filter__group-mileagelabel');
    var $colourList = $('.js-stock-colour');
    var $dropdownSortBy = $('.js-stock-sortby');

    const PRICE_RANGE = {
        MIN: 0, MAX: 200000
    };
    const YEAR_RANGE = {
        MIN: 2000, MAX: new Date().getFullYear() + 1
    };
    const MILEAGE_RANGE = {
        MIN: 0, MAX: 100000
    };

    const SORTBY = {
        LISTINGDATE: 0,
        YEAR: 1,
        PRICE: 2,
        ODOMETER: 3,
        FEATURED: 5
    };

    const SORTORDER = {
        ASCENDING: 0,
        DESCENDING: 1
    };

    const SortObj = {
        Featured: { 
            SortBy: SORTBY.LISTINGDATE,  // SORTBY.FEATURED,
            SortOrder: SORTORDER.ASCENDING
        },
        PriceHL: {
            SortBy: SORTBY.PRICE,
            SortOrder: SORTORDER.DESCENDING
        },
        PriceLH: {
            SortBy: SORTBY.PRICE,
            SortOrder: SORTORDER.ASCENDING
        },
        YearHL: {
            SortBy: SORTBY.YEAR,
            SortOrder: SORTORDER.DESCENDING
        },
        YearLH: {
            SortBy: SORTBY.YEAR,
            SortOrder: SORTORDER.ASCENDING
        },        
        //MileageHL: {
        //    SortBy: SORTBY.ODOMETER,
        //    SortOrder: SORTORDER.DESCENDING
        //},
        //MileageLH: {
        //    SortBy: SORTBY.ODOMETER,
        //    SortOrder: SORTORDER.ASCENDING
        //}
    };

    var $searchParam = {
        specialOffer: false,
        ranges: [],
        modelNames: [],
        groupedTypes: [],
        bodyTypes: [],
        engineTypes: [],
        locations: [],
        priceFrom: null,
        priceTo: null,
        yearFrom: null,
        yearTo: null,
        mileageFrom: null,
        mileageTo: null,
        colours: [],
        yardCodes: [],

        selectedSort: 'Featured',
        pageIndex: 1,
        pageSize: 36
    };

    function translateSearchParams() {
        var paramArr = [];

        if ($typeOfStockPage == 'New') {
            paramArr.push('searchTypes=' + 'New');
        }
        else {
            paramArr.push('searchTypes=' + $typeOfStockPage); //can be 'All' or 'Used,Demo'
        }

        if ($searchParam.yardCodes.length > 0) {
            paramArr.push('yardCodes=' + $searchParam.yardCodes.join());
        }



        if ($searchParam.specialOffer) {
            paramArr.push(`specialOffers=true`)
        }

        //var tmpKeyword = 'LFS407';
        //paramArr.push('keyword=' + tmpKeyword);
      
        //var sortBy = 0; // 0: listing Date, 1: year, 2: price, 3: Odometer
        //paramArr.push('sortBy=' + sortBy);

        if ($searchParam.ranges.length > 0) {
            paramArr.push('stockRange=' + $searchParam.ranges.join());
        }

        if ($searchParam.modelNames.length > 0) {
            paramArr.push('modelName=' + $searchParam.modelNames.join());
        }

        if ($searchParam.groupedTypes.length > 0) {
            paramArr.push('groupedType=' + $searchParam.groupedTypes.join());
        }

      
        if ($searchParam.bodyTypes.length > 0) {
            paramArr.push('bodyType=' + $searchParam.bodyTypes.join());
        }

        if ($searchParam.engineTypes.length > 0) {
            paramArr.push('engineType=' + $searchParam.engineTypes.join());
        }

        if ($searchParam.locations.length > 0) {
            paramArr.push('location=' + $searchParam.locations.join());
        }

        if ($searchParam.priceFrom != null) {
            paramArr.push('priceFrom=' + $searchParam.priceFrom);
        }

        if ($searchParam.priceTo != null) {
            paramArr.push('priceTo=' + $searchParam.priceTo);
        }

        if ($searchParam.yearFrom != null) {
            paramArr.push('yearFrom=' + $searchParam.yearFrom);
        }

        if ($searchParam.yearTo != null) {
            paramArr.push('yearTo=' + $searchParam.yearTo);
        }

        if ($searchParam.mileageFrom != null) {
            paramArr.push('mileageFrom=' + $searchParam.mileageFrom);
        }

        if ($searchParam.mileageTo != null) {
            paramArr.push('mileageTo=' + $searchParam.mileageTo);
        }
       
        if ($searchParam.colours.length > 0) {
            paramArr.push('colour=' + $searchParam.colours.join());
        }                       

        paramArr.push('sortBy=' + SortObj[$searchParam.selectedSort].SortBy);
        paramArr.push('sortOrder=' + SortObj[$searchParam.selectedSort].SortOrder);
        paramArr.push('page=' + $searchParam.pageIndex);
        paramArr.push('pageSize=' + $searchParam.pageSize);

        if (paramArr.length > 0) {
            return '?' + paramArr.join('&');
        }
        else {
            return null;
        }
    }

    function loadStockSearchResult(_paramStr) {
        var _url = '/app/nz/api/stockfinder/getstocklist';
        var _searchUrl = _url + _paramStr;
        $.ajax({
            type: 'GET',
            url: _searchUrl,
            success: function (data) {
                $('#stock-tiles').html(data);

                var _totalEle = $('input[type="hidden"][name="stocksearchTotalResults"]');
                if (_totalEle.length > 0) {
                    $('.js-stock-total')[0].innerText = _totalEle[0].value;
                }
                else {
                    $('.js-stock-total')[0].innerText = '0';
                }
            },
            error: function (response) {
                console.log(response);
            }
        });
    }

    function triggerStockSearch() {
        var _allparamStr = translateSearchParams();
        loadStockSearchResult(_allparamStr);
        history.pushState(null, null, _allparamStr);
    }

    function syncSearchBoxAndSearchParamObj(_dictionary) {
        if ('yardcodes' in _dictionary) {
            var _yardCodeArr = _dictionary['yardcodes'].split(',');
            $searchParam.yardCodes = _yardCodeArr;
        }

        if ('stockrange' in _dictionary) {
            var _rangeArr = _dictionary['stockrange'].split(',');
            $searchParam.ranges = _rangeArr;

            var elements = document.querySelectorAll('input[type="checkbox"][name="rangeName"]');
            elements.forEach(function (e) {
                if (_rangeArr.indexOf($(e).attr('data-stockrange').toLowerCase()) > -1) {
                    e.checked = true;
                    $searchParam.modelNames.push(e.value.toLowerCase());
                }
            });
        }

        if ('specialoffers' in _dictionary) {
            $searchParam.specialOffer = true
            let field = document.querySelectorAll('input[type="checkbox"][name="specialOffers"]');
            field.checked = true;
           
        }

        if ('groupedtype' in _dictionary) {
            var _groupedTypeArr = _dictionary['groupedtype'].split(',');
            $searchParam.groupedTypes = _groupedTypeArr;

            var elements = document.querySelectorAll('input[type="checkbox"][name="bodyType"]');
            elements.forEach(function (e) {
                if (_groupedTypeArr.indexOf($(e).attr('data-stockbodytype').toLowerCase()) > -1) {
                    e.checked = true;
                    $searchParam.bodyTypes.push(e.value.toLowerCase());
                }
            });
        }

        if ('enginetype' in _dictionary) {
            var _engineTypeArr = _dictionary['enginetype'].split(',');
            $searchParam.engineTypes = _engineTypeArr;

            var elements = document.querySelectorAll('input[type="checkbox"][name="engineType"]');
            elements.forEach(function (e) {
                if (_engineTypeArr.indexOf(e.value.toLowerCase()) > -1) {
                    e.checked = true;
                }
            });
        }

        if ('location' in _dictionary) {
            var _locationArr = _dictionary['location'].split(',');
            $searchParam.locations = _locationArr;

            var elements = document.querySelectorAll('input[type="checkbox"][name="stockCity"]');
            elements.forEach(function (e) {
                if (_locationArr.indexOf(e.value.toLowerCase()) > -1) {
                    e.checked = true;
                }
            });
        }

        var _priceMin = ('pricefrom' in _dictionary) ? _dictionary['pricefrom'] : null;
        var _priceMax = ('priceto' in _dictionary) ? _dictionary['priceto'] : null;
        $searchParam.priceFrom = _priceMin;
        $searchParam.priceTo = _priceMax;   
        $sliderPrice.noUiSlider.set([ _priceMin, _priceMax ]);

        var _yearMin = ('yearfrom' in _dictionary) ? _dictionary['yearfrom'] : null;
        var _yearMax = ('yearto' in _dictionary) ? _dictionary['yearto'] : null;
        $searchParam.yearFrom = _yearMin;
        $searchParam.yearTo = _yearMax;
        $sliderYear.noUiSlider.set([ _yearMin, _yearMax ]);

        var _mileageMin = ('mileagefrom' in _dictionary) ? _dictionary['mileagefrom'] : null;
        var _mileageMax = ('mileageto' in _dictionary) ? _dictionary['mileageto'] : null;
        $searchParam.mileageFrom = _mileageMin;
        $searchParam.mileageTo = _mileageMax;
        $sliderMilage.noUiSlider.set([ _mileageMin, _mileageMax]);           

        if ('colour' in _dictionary) {
            var _colourArr = _dictionary['colour'].split(',');
            $searchParam.colours = _colourArr;

            $colourList.toArray().forEach(function (item) {
                if (_colourArr.indexOf($(item).attr('data-colourName').toLowerCase()) > -1) {
                    $(item).addClass('selected');
                }
            });            
        }

        var _sortBy = ('sortby' in _dictionary) ? parseInt(_dictionary['sortby']) : SORTBY.LISTINGDATE;
        var _sortOrder = ('sortorder' in _dictionary) ? parseInt(_dictionary['sortorder']) : SORTORDER.DESCENDING;
        $searchParam.selectedSort = 'Featured';

        // get key by value pair
        for (var prop in SortObj) {
            if (SortObj.hasOwnProperty(prop)) {
                if (SortObj[prop].SortBy === _sortBy && SortObj[prop].SortOrder === _sortOrder) {
                    //console.log(prop);
                    $searchParam.selectedSort = prop;
                }
            }
        } 

        if ('page' in _dictionary) {
            $searchParam.pageIndex = _dictionary['page'];
        }
    }

    function parseQueryStringToDictionary(queryString) {
        var dictionary = {};

        // remove the '?' from the beginning of the string
        if (queryString.indexOf('?') === 0) {
            queryString = queryString.substr(1);
        }

        var parts = queryString.split('&');

        for (var i = 0; i < parts.length; i++) {
            var p = parts[i];
            var keyValuePair = p.split('=');

            var key = keyValuePair[0].toLowerCase();
            var value = keyValuePair[1];

            value = decodeURIComponent(value);
            value = value.replace(/\+/g, ' ');

            dictionary[key] = value;
        }

        return dictionary;
    }

    function processQueryString() {
        var queryString = window.location.search.substring(1).toLowerCase();

        if (queryString.length > 0) {
            queryString = decodeURIComponent(queryString);           
            var dict = parseQueryStringToDictionary(queryString);                     
            syncSearchBoxAndSearchParamObj(dict);
        }
    }

    function modelNameHeaderUpdate() {
        var _modelNameHeader = $('.js-model-name-header')[0];
        if ($searchParam.ranges.length > 1) {
            _modelNameHeader.innerText = $searchParam.ranges.length + ' Models Selected';
        }
        else if ($searchParam.ranges.length == 1) {
            _modelNameHeader.innerText = '1 Model Selected';
        }
        else {
            _modelNameHeader.innerText = 'Model';
        }
    }

    function bodyTypeHeaderUpdate() {
        var _bodyTypeHeader = $('.js-body-type-header')[0];
        if ($searchParam.groupedTypes.length > 1) {
            _bodyTypeHeader.innerText = $searchParam.groupedTypes.length + ' Body Types Selected';
        }
        else if ($searchParam.groupedTypes.length == 1) {
            _bodyTypeHeader.innerText = '1 Body Type Selected';
        }
        else {
            _bodyTypeHeader.innerText = 'Body Type';
        }
    }

    function engineTypeHeaderUpdate() {
        var _engineTypeHeader = $('.js-engine-type-header')[0];
        if ($searchParam.engineTypes.length > 1) {
            _engineTypeHeader.innerText = $searchParam.engineTypes.length + ' Engine Types Selected';
        }
        else if ($searchParam.engineTypes.length == 1) {
            _engineTypeHeader.innerText = '1 Engine Type Selected';
        }
        else {
            _engineTypeHeader.innerText = 'Engine Type';
        }
    }

    function colourHeaderUpdate() {
        var _colourTypeHeader = $('.js-colour-header')[0];
        if ($searchParam.colours.length > 1) {
            _colourTypeHeader.innerText = $searchParam.colours.length + ' Colours Selected';
        }
        else if ($searchParam.colours.length == 1) {
            _colourTypeHeader.innerText = '1 Colour Selected';
        }
        else {
            _colourTypeHeader.innerText = 'Colour';
        }
    }

    function locationHeaderUpdate() {
        var _ele = $('.js-stock-city-header');
        if (_ele.length == 0) {
            return;
        }

        var _locationHeader = _ele[0];

        if ($searchParam.locations.length > 1) {
            _locationHeader.innerText = '(' + $searchParam.locations.length + ') Locations Selected';
        }
        else if ($searchParam.locations.length == 1) {
            _locationHeader.innerText = '1 Location Selected';
        }
        else {
            _locationHeader.innerText = 'Location';
        }
    }

    function resetCheckboxList(_name) {
        var _selector = 'input[type="checkbox"][name="' + _name + '"]';
        var _checkboxes = document.querySelectorAll(_selector);
        _checkboxes.forEach(function (e) {
            if (e.checked) {
                e.checked = false;
            }
        });
    }

    function checkResetFilter() {
        if ($searchParam.modelNames.length == 0 && $searchParam.bodyTypes.length == 0 && $searchParam.colours.length == 0 && $searchParam.engineTypes.length == 0 && $searchParam.locations.length == 0 &&
            ($searchParam.priceFrom == null || $searchParam.priceFrom == PRICE_RANGE.MIN) &&
            ($searchParam.priceTo == null || $searchParam.priceTo == PRICE_RANGE.MAX) &&
            ($searchParam.yearFrom == null || $searchParam.yearFrom == YEAR_RANGE.MIN) &&
            ($searchParam.yearTo == null || $searchParam.yearTo == YEAR_RANGE.MAX) &&
            ($searchParam.specialOffer === false) &&
            ($searchParam.mileageFrom == null || $searchParam.mileageFrom == MILEAGE_RANGE.MIN) &&
            ($searchParam.mileageTo == null || $searchParam.mileageTo == MILEAGE_RANGE.MAX)) {

            $filterResetBtn.hide();
        }
        else {
            $filterResetBtn.show();
        }
    }

    function initRanges() {       
        noUiSlider.create($sliderPrice, {
            range: {
                'min': PRICE_RANGE.MIN,
                'max': PRICE_RANGE.MAX
            },
            step: 5000,
            start: [PRICE_RANGE.MIN, PRICE_RANGE.MAX],
            connect: true,
            tooltips: false,
            format: {
                to: function (value) {
                    return parseInt(value);
                },
                from: function (value) {
                    return parseInt(value);
                }
            }
        });

        $sliderPrice.noUiSlider.on('update', function () { 

            var moneyFormat = wNumb({ mark: '.', thousand: ',', prefix: '$' });
            
            var prices = $sliderPrice.noUiSlider.get();
            
            $sliderPriceLabel.text(`${moneyFormat.to(prices[0])} - ${moneyFormat.to(prices[1])}${prices[1] === PRICE_RANGE.MAX ? '+' : ''}`);

        });


        noUiSlider.create($sliderYear, {
            range: {
                'min': YEAR_RANGE.MIN,
                'max': YEAR_RANGE.MAX
            },
            step: 1,
            start: [YEAR_RANGE.MIN, YEAR_RANGE.MAX],
            connect: true,
            tooltips: false,
            format: {
                to: function (value) {
                    return parseInt(value);
                },
                from: function (value) {
                    return parseInt(value);
                }
            }
        });

        $sliderYear.noUiSlider.on('update', function () {

            var years = $sliderYear.noUiSlider.get();
            $sliderYearLabel.text(`${years[0]} - ${years[1]}${years[1] === YEAR_RANGE.MAX ? '+' : ''}`);

        });

        noUiSlider.create($sliderMilage, {
            range: {
                'min': MILEAGE_RANGE.MIN,
                'max': MILEAGE_RANGE.MAX
            },
            step: 5000,
            start: [MILEAGE_RANGE.MIN, MILEAGE_RANGE.MAX],
            connect: true,
            tooltips: false,
            format: {
                to: function (value) {
                    return parseInt(value);
                },
                from: function (value) {
                    return parseInt(value);
                }
            }
        });

        $sliderMilage.noUiSlider.on('update', function () {
            var milageFormat = wNumb({ mark: '.', thousand: ','});

            var miles = $sliderMilage.noUiSlider.get();
            $sliderMileageLabel.text(`${milageFormat.to(miles[0])}km - ${milageFormat.to(miles[1])}km${miles[1] === MILEAGE_RANGE.MAX ? '+' : ''}`);
        });
        
    };

    return {
        init: function () {
            if (!$sidebar.length) { return false; }
            initRanges();

            // * model range
            $('input[type="checkbox"][name="rangeName"]').on('change', function () {
                var _modelList = this.value.toLowerCase();
                var _rangeName = $(this).attr('data-stockrange').toLowerCase();
                if (this.checked) {
                    $searchParam.ranges.push(_rangeName);
                    $searchParam.modelNames.push(_modelList);
                } else {
                    var i = $searchParam.modelNames.indexOf(_modelList);
                    $searchParam.modelNames.splice(i, 1);
                    var j = $searchParam.ranges.indexOf(_rangeName);
                    $searchParam.ranges.splice(j, 1);
                }
                $searchParam.pageIndex = 1;
                //console.log($searchParam);
                modelNameHeaderUpdate();
                checkResetFilter();
                triggerStockSearch();
            });

            $('input[type="checkbox"][name="specialOffers"]').on('change', function () {

                $searchParam.specialOffer = this.checked;
                checkResetFilter();
                triggerStockSearch();
            }
            );

            // * body type
            $('input[type="checkbox"][name="bodyType"]').on('change', function () {
                var bodyTypeList = this.value.toLowerCase();
                var _groupedName = $(this).attr('data-stockbodytype').toLowerCase();
                if (this.checked) {
                    $searchParam.groupedTypes.push(_groupedName);
                    $searchParam.bodyTypes.push(bodyTypeList);
                } else {
                    var i = $searchParam.bodyTypes.indexOf(bodyTypeList);
                    $searchParam.bodyTypes.splice(i, 1);
                    var j = $searchParam.groupedTypes.indexOf(_groupedName);
                    $searchParam.groupedTypes.splice(j, 1);
                }
                $searchParam.pageIndex = 1;
                //console.log($searchParam);
                bodyTypeHeaderUpdate();
                checkResetFilter();
                triggerStockSearch();
            });

            // * engine type
            $('input[type="checkbox"][name="engineType"]').on('change', function () {
                var _engineType = this.value.toLowerCase();
                if (this.checked) {
                    $searchParam.engineTypes.push(_engineType);
                } else {
                    var i = $searchParam.engineTypes.indexOf(_engineType);
                    $searchParam.engineTypes.splice(i, 1);
                }
                $searchParam.pageIndex = 1;
                //console.log($searchParam);
                engineTypeHeaderUpdate();
                checkResetFilter();
                triggerStockSearch();
            });

            // * location
            $('input[type="checkbox"][name="stockCity"]').on('change', function () {
                var location = this.value.toLowerCase();
                if (this.checked) {
                    $searchParam.locations.push(location);
                } else {
                    var i = $searchParam.locations.indexOf(location);
                    $searchParam.locations.splice(i, 1);
                }
                $searchParam.pageIndex = 1;
                //console.log($searchParam);
                locationHeaderUpdate();
                checkResetFilter();
                triggerStockSearch();
            });

            // * price
            $sliderPrice.noUiSlider.on('change', function (values) {
                $searchParam.priceFrom = values[0];
                $searchParam.priceTo = (values[1] == PRICE_RANGE.MAX) ? null : values[1];
                $searchParam.pageIndex = 1;
                //console.log($searchParam);
                checkResetFilter();
                triggerStockSearch();
            });

            // * year
            $sliderYear.noUiSlider.on('change', function (values) {
                $searchParam.yearFrom = values[0];
                $searchParam.yearTo = values[1];
                $searchParam.pageIndex = 1;
                //console.log($searchParam);
                checkResetFilter();
                triggerStockSearch();
            });

            // * milage
            $sliderMilage.noUiSlider.on('change', function (values) {
                $searchParam.mileageFrom = values[0];
                $searchParam.mileageTo = (values[1] == MILEAGE_RANGE.MAX) ? null : values[1];
                $searchParam.pageIndex = 1;
                //console.log($searchParam);
                checkResetFilter();
                triggerStockSearch();
            });

            // * colour
            $colourList.on('click', function () {
                var _colourName = $(this).attr('data-colourName').toLowerCase();
                var i = $searchParam.colours.indexOf(_colourName);
                if (i > -1) {
                    $searchParam.colours.splice(i, 1);
                    $(this).removeClass('selected');
                }
                else {
                    $searchParam.colours.push(_colourName);
                    $(this).addClass('selected');
                }
                $searchParam.pageIndex = 1;
                //console.log($searchParam);
                colourHeaderUpdate();
                checkResetFilter();
                triggerStockSearch();
            });

            // * sorting
            $dropdownSortBy.on('change', function () {
                $searchParam.selectedSort = this.value;
                //console.log($searchParam);
                triggerStockSearch();
            });

            // pagination
            $(document).on('click', '.js-page-link', function () {
                $searchParam.pageIndex = $(this).text().trim();
                //console.log($searchParam);
                triggerStockSearch();              
            });

            $filterResetBtn.on('click', function () {
                $searchParam.modelNames = [];
                $searchParam.ranges = [];
                $searchParam.bodyTypes = [];
                $searchParam.groupedTypes = [];
                $searchParam.specialOffer = false;
                $searchParam.engineTypes = [];
                $searchParam.locations = [];
                $searchParam.priceFrom = null;
                $searchParam.priceTo = null;
                $searchParam.yearFrom = null;
                $searchParam.yearTo = null;
                $searchParam.mileageFrom = null;
                $searchParam.mileageTo = null;
                $searchParam.colours = [];
                $searchParam.selectedSort = 'Featured';
                $searchParam.pageIndex = 1;

                $('.js-model-name-header')[0].innerText = 'Model';
                $('.js-body-type-header')[0].innerText = 'Body Type';
                $('.js-engine-type-header')[0].innerText = 'Engine Type';                
                $('.js-colour-header')[0].innerText = 'Colour';

                resetCheckboxList('rangeName');
                resetCheckboxList('bodyType');
                resetCheckboxList('engineType');
                resetCheckboxList('specialOffers');

                var _locationHeaderEle = $('.js-stock-city-header');
                if (_locationHeaderEle.length > 0) {
                    _locationHeaderEle[0].innerText = 'Location';
                    resetCheckboxList('stockCity');
                }    

                $sliderPrice.noUiSlider.set([PRICE_RANGE.MIN, PRICE_RANGE.MAX]);
                $sliderYear.noUiSlider.set([YEAR_RANGE.MIN, YEAR_RANGE.MAX]);
                $sliderMilage.noUiSlider.set([MILEAGE_RANGE.MIN, MILEAGE_RANGE.MAX]);

                $colourList.removeClass('selected');
                $dropdownSortBy[0].selectedIndex = 0;

                $filterResetBtn.hide();

                triggerStockSearch();
            });


            processQueryString();
            var params = translateSearchParams();
            //console.log(params);
            modelNameHeaderUpdate();
            bodyTypeHeaderUpdate();
            engineTypeHeaderUpdate();
            locationHeaderUpdate();
            colourHeaderUpdate();
            checkResetFilter();            
            loadStockSearchResult(params);                        
        }
    };
}());

VOLKSWAGEN.StockSearch.init();


VOLKSWAGEN.Deposit = (function () {
    var $depositVehicle = $('#deposit-result');
    var $depositForm = $('#makeDeposit');

    function collectFormHiddenFields(_form) {
        //console.log(JSON.parse($depositVehicle.attr('data-cardata')));
        var _vehicle = JSON.parse($depositVehicle.attr('data-cardata'));

        var thumbnail = _form.find('.umbraco-forms-field.thumbnail input:hidden')[0];
        thumbnail.value = _vehicle.ThumbnailUrl;

        var carModel = _form.find('.umbraco-forms-field.carmodel input:hidden')[0];
        carModel.value = _vehicle.ModelName;

        var variant = _form.find('.umbraco-forms-field.variant input:hidden')[0];
        variant.value = _vehicle.Variant;       

        var vehicleprice = _form.find('.umbraco-forms-field.vehicleprice input:hidden')[0];
        vehicleprice.value = '$' + Number(_vehicle.MRP.toFixed(1)).toLocaleString();

        var description = _form.find('.umbraco-forms-field.description input:hidden')[0];
        description.value = '';

        var _modelCode = getURLParameter('modelcode');
        var _listingSeq = getURLParameter('listingSeq');
        if (!!_modelCode) {
            var modelcode = _form.find('.umbraco-forms-field.modelcode input:hidden')[0];
            modelcode.value = _modelCode;
            
            if (!!getURLParameter('wid') && !!getURLParameter('cid')) {                
                description.value = 'Paint: ' + _vehicle.ColourName + ', Alloy: ' + _vehicle.WheelName;  
            }
        }
        else if (!!_listingSeq) {
            var listingseq = _form.find('.umbraco-forms-field.listingseq input:hidden')[0];
            listingseq.value = _listingSeq;

            var vin = _form.find('.umbraco-forms-field.vin input:hidden')[0];
            vin.value = _vehicle.VIN;

            var registration = _form.find('.umbraco-forms-field.registration input:hidden')[0];
            registration.value = _vehicle.Registration;

            description.value = 'Mileage: ' + Number(_vehicle.Mileage.toFixed(1)).toLocaleString() + ' km, Engine: ' + _vehicle.Engine + 'cc, Fuel Type: ' + _vehicle.FuelType + ', Stock No: ' + _vehicle.StockNo; 
        }
                
    }

    return {
        init: function () {
            if (!$depositForm.length) { return false; }

            collectFormHiddenFields($depositForm);
        }
    };
}());

VOLKSWAGEN.Deposit.init();


VOLKSWAGEN.VehicleEnquiry = (function () {
    var $enquiryForm = $('#vehicleEnquiry');
    var $enquiryBtn = $('.js-vehicleEnquiryBtn');

    function collectFormHiddenFields(_form) {
        var _stock = JSON.parse($enquiryBtn.attr('data-cardata'));

        var _introText = _form.find('.umbraco-forms-field.title p')[0];
        if (_stock.IsEMDNewStock != 1) {
            _introText.innerHTML = _introText.innerHTML.replace("your preferred", "a Volkswagen Authorised");
        }

        var carModel = _form.find('.umbraco-forms-field.carmodel input:hidden')[0];
        carModel.value = _stock.Year + ' ' + _stock.Make + ' ' + _stock.ModelName + ' ' + _stock.Variant;

        var registration = _form.find('.umbraco-forms-field.registration input:hidden')[0];
        registration.value = _stock.Registration;

        var listingseq = _form.find('.umbraco-forms-field.listingseq input:hidden')[0];
        listingseq.value = _stock.ListingSeq;

        var yardcode = _form.find('.umbraco-forms-field.stockyardcode input:hidden')[0];
        yardcode.value = _stock.YardCode;

        var vin = _form.find('.umbraco-forms-field.vin input:hidden')[0];
        vin.value = _stock.VIN;

        var dealerField = _form.find('.umbraco-forms-field.crmcitydealerselector')[0];
        if ($(dealerField).is(":hidden") == true) {
            var _dealer = _form.find('.js-citydealers-hidden')[0];
            _dealer.value = _stock.UsedStockDealerInfo;
        }

        dataLayer.push({
            'event': 'VWStockSearchResult_Load',
            'modelName': _stock.Make + ' ' + _stock.ModelName
        });
    }

    return {
        init: function () {
            if (!$enquiryForm.length) { return false; }

            collectFormHiddenFields($enquiryForm);

            $($enquiryBtn).on('click', function () {
                $enquiryForm[0].style.display = 'block';
            });

            $($enquiryForm).on('click', '.close', function () {
                $enquiryForm[0].style.display = "none";
            });

        }
    };
}());

VOLKSWAGEN.VehicleEnquiry.init();


VOLKSWAGEN.PurchaseServicePlan = (function () {
    var $form = $('#purchaseService');
    var $validateRegoBtn = $('#js-validateServiceRego');
    var servicePlanDDWrapper = $('#js-servicePlanSelector');
    var $vehicleType = $('.umbraco-forms-field.vehicletype input:hidden')[0];
    var $planDropdown;
    var $submitBtn = null;
    var $spInfoMsg = $('.js-validateRego-info-msg')[0];

    var modelName = null;
    var priceList = null;
    var selectedPlan = null;
    var tcUrl = null;

    function validateRego() {
        var $serviceRego = $('#serviceRego');
        var _rego = $serviceRego.val();
        if (typeof (_rego) == 'undefined' || _rego == null || _rego == '') {
            console.log('Required Rego');
            return;
        }

        _rego = _rego.replace(/\s+/g, '');
        var $regoErrorMsg = $('.js-validateRego-error-msg')[0];
        var $regoWarnMsg = $('#purchaseService').find('.umbraco-forms-field.warningmessage')[0];

        var _url = '/app/nz/api/purchaseservice/validate?rego=' + _rego;
        $.ajax({
            type: 'POST',
            url: _url,
            success: function (response) {

                if (response.Eligible) {
                    $serviceRego[0].readOnly = true;
                    collectServicePlanData(response);

                    $vehicleType.value = response.VehicleType;

                    if (response.PriceList) {
                        var _plans = Object.keys(response.PriceList);

                        if (_plans.length > 0) {

                            updateSPplanDropdown(_plans);
                            servicePlanDDWrapper[0].style.display = "block";

                            $spInfoMsg.innerHTML = updateServicePlanInfoText(selectedPlan, response.VehicleModel);
                            $spInfoMsg.style.display = "block";

                            $regoWarnMsg.style.display = "none";
                            $regoErrorMsg.style.display = "none";
                            $validateRegoBtn[0].style.display = "none";

                            $submitBtn.closest('.forms-submit-row').style.cursor = 'pointerd';
                            $submitBtn.style.pointerEvents = 'auto';
                        }
                        else {
                            displayInfoPanelwithWarnMsg();
                        }                        
                    }
                    else {
                        displayInfoPanelwithWarnMsg();
                    }
                    
                }
                else {
                    $regoErrorMsg.style.display = "block";
                }
            },
            error: function (response) {
                console.log(response);
            }
        });
    }

    function collectServicePlanData(_resp) {
        modelName = _resp.VehicleModel;
        priceList = _resp.PriceList;

        var _carmodel = $('.umbraco-forms-field.carmodel input:hidden')[0];
        _carmodel.value = (modelName != null) ? modelName : 'Unknown';
    }

    function updateSPplanDropdown(_availablePlans) {
        _availablePlans.forEach(function (e) {
            var option = document.createElement("option");
            option.text = e;
            option.value = e;
            $planDropdown[0].add(option);
        });
    }

    function displayInfoPanelwithWarnMsg() {
        $spInfoMsg.innerHTML = 'Sorry, we can\'t validate your registration at this time, please contact us.';
        $spInfoMsg.style.display = "block";
    }

    function updateServicePlanInfoText(_selectedPlan, _modelName) {
        var _infoTxt = 'Model: ' + _modelName + '<br />Your vehicle is eligible to purchase a Volkswagen Scheduled Service Plan <br /><br />';

        if (!_selectedPlan) {
            return _infoTxt;
        }

        if (priceList != null) {
            var found = Object.keys(priceList).find(e => _selectedPlan.includes(e));

            switch (_selectedPlan.charAt(0)) {
                case '3':
                case '6':
                    _infoTxt = _infoTxt + _selectedPlan + ' Service Plan Cost: $' + priceList[found].Price + '<br />'
                        + 'Inclusions: <br />'
                        + 'Comprehensive 30-point safety inspection, a diagnostic and software check and the services listed below. <br />'
                        + '• First Service - ' + priceList[found].FirstServiceInclusions + '<br />'
                        + '• Second Service - ' + priceList[found].SecondServiceInclusions + '<br />'
                        + '• Third Service - ' + priceList[found].ThirdServiceInclusions + '<br /><br />';
                    break;
                case '2':
                case '4':
                    _infoTxt = _infoTxt + _selectedPlan + ' Service Plan Cost: $' + priceList[found].Price + '<br />'
                        + 'Inclusions: <br />'
                        + 'Comprehensive 30-point safety inspection, a diagnostic and software check and the services listed below. <br />'
                        + '• First Service - ' + priceList[found].FirstServiceInclusions + '<br />'
                        + '• Second Service - ' + priceList[found].SecondServiceInclusions + '<br /><br />';
                    break;
                case '5':
                    _infoTxt = _infoTxt + _selectedPlan + ' Service Plan Cost: $' + priceList[found].Price + '<br />'
                        + 'Inclusions: <br />'
                        + 'Comprehensive 30-point safety inspection, a diagnostic and software check and the services listed below. <br />'
                        + '• First Service - ' + priceList[found].FirstServiceInclusions + '<br />'
                        + '• Second Service - ' + priceList[found].SecondServiceInclusions + '<br />'
                        + '• Third Service - ' + priceList[found].ThirdServiceInclusions + '<br />'
                        + '• Fourth Service - ' + priceList[found].FourthServiceInclusions + '<br />'
                        + '• Fifth Service - ' + priceList[found].FifthServiceInclusions + '<br /><br />';
                    break;
            }


            if (modelName.toLowerCase().indexOf("amarok") > -1) {
                tcUrl = $form.attr('data-amarok-url');
            }
            else if ($vehicleType.value.includes("commercial")) {
                tcUrl = $form.attr('data-commercial-url');
            }
            else {
                tcUrl = $form.attr('data-passenger-url');
            }

            if (tcUrl) {
                _infoTxt = _infoTxt + '<a href="' + tcUrl + '" target="_blank">Terms and conditions</a>';
            }           
        }
        return _infoTxt;
    }

    return {
        init: function () {            
            if (!$form.length) { return false; }

            $planDropdown = $(servicePlanDDWrapper).find('select');

            $($planDropdown).on('change', function () {
                selectedPlan = this.value;
                if (priceList != null) {
                    $spInfoMsg.innerHTML = updateServicePlanInfoText(this.value, modelName);
                }
            });

            $validateRegoBtn.on('click', function () {
                validateRego();
            });

            $submitBtn = $($form).find('.vw-formsubmit-button')[0];
            if ($submitBtn != null) {
                $submitBtn.closest('.forms-submit-row').style.cursor = 'not-allowed';
                $submitBtn.style.pointerEvents = 'none';
            }

            $($form).on('click', '.vw-formsubmit-button', function () {
                var found = Object.keys(priceList).find(e => selectedPlan.includes(e));

                var _price = $('.umbraco-forms-field.price input:hidden')[0];
                _price.value = priceList[found].Price;

                if (priceList[found].FirstServiceInclusions) {
                    var _spInclusions1 = $('.umbraco-forms-field.inclusions1 input:hidden')[0];
                    _spInclusions1.value = 'First service - ' + priceList[found].FirstServiceInclusions;
                }

                if (priceList[found].SecondServiceInclusions) {
                    var _spInclusions2 = $('.umbraco-forms-field.inclusions2 input:hidden')[0];
                    _spInclusions2.value = 'Second service - ' + priceList[found].SecondServiceInclusions;
                }

                if (priceList[found].ThirdServiceInclusions) {
                    var _spInclusions3 = $('.umbraco-forms-field.inclusions3 input:hidden')[0];
                    _spInclusions3.value = 'Third service - ' + priceList[found].ThirdServiceInclusions;
                }

                if (priceList[found].FourthServiceInclusions) {
                    var _spInclusions4 = $('.umbraco-forms-field.inclusions4 input:hidden')[0];
                    _spInclusions4.value = 'Fourth service - ' + priceList[found].FourthServiceInclusions;
                }

                if (priceList[found].FifthServiceInclusions) {
                    var _spInclusions5 = $('.umbraco-forms-field.inclusions5 input:hidden')[0];
                    _spInclusions5.value = 'Fifth service - ' + priceList[found].FifthServiceInclusions;
                }

            });
        }
    };
}());

VOLKSWAGEN.PurchaseServicePlan.init();


VOLKSWAGEN.ServicePlanPaymentPlans = (function () {
    var $form = $('#servicePaymentPlan');
    var $validateRegoBtn = $('#js-validateServicePlanRego');
    var servicePlanDDWrapper = $('#js-servicePlanSelector');
    var $vehicleType = $('.umbraco-forms-field.vehicletype input:hidden')[0];

    const FALLBACK_TERM = 12;
    var flexTermWrapper = $('#js-servicePlanTermWrapper');
    var $sliderFlexTermLabel = $('.js-flex-term-label');
    var $sliderFlexTerm = document.getElementById('flex-term-range');
    var $planDropdown;
    var $submitBtn = null;
    var $spInfoPanel = $('.js-validateRego-info-msg')[0];

    var modelName = null;
    var priceList = null;
    var selectedPlan = null;
    var selectedMonth = FALLBACK_TERM;
    var tcUrl = null;

    function validateRego() {        
        var $servicePlanRego = $('#servicePlanRego');
        var _rego = $servicePlanRego.val();
        if (typeof (_rego) == 'undefined' || _rego == null || _rego == '') {
            console.log('Required Rego');
            return;
        }

        _rego = _rego.replace(/\s+/g, '');
        var $regoErrorMsg = $('.js-validateRego-error-msg')[0];
        var $regoWarnMsg = $($form).find('.umbraco-forms-field.warningmessage')[0];

        var _url = '/app/nz/api/servicemonthlypay/validate?rego=' + _rego;
        $.ajax({
            type: 'POST',
            url: _url,
            success: function (response) {

                if (response.Eligible) {
                    $servicePlanRego[0].readOnly = true;
                    collectServicePaymentPlanData(response);
                    
                    $vehicleType.value = response.VehicleType;                                        

                    if (response.PriceList) {
                        var _plans = Object.keys(response.PriceList);
                                                
                        if (_plans.length > 0) {

                            updateSPPPplanDropdown(_plans);
                            servicePlanDDWrapper[0].style.display = "block";
                            

                            $spInfoPanel.innerHTML = updateServicePaymentPlanInfoText(selectedPlan, response.VehicleModel, FALLBACK_TERM);
                            $spInfoPanel.style.display = "block";

                            $regoWarnMsg.style.display = "none";
                            $regoErrorMsg.style.display = "none";
                            $validateRegoBtn[0].style.display = "none";

                            $submitBtn.closest('.forms-submit-row').style.cursor = 'pointerd';
                            $submitBtn.style.pointerEvents = 'auto';
                        }
                        else {
                            displayInfoPanelwithWarnMsg();
                        }
                        
                    }
                    else {
                        displayInfoPanelwithWarnMsg();
                    }

                }
                else {
                    $regoErrorMsg.style.display = "block";
                }
            },
            error: function (response) {
                console.log(response);
            }
        });
    }

    function collectServicePaymentPlanData(_resp) {
        modelName = _resp.VehicleModel;
        priceList = _resp.PriceList;

        var _carmodel = $('.umbraco-forms-field.carmodel input:hidden')[0];
        _carmodel.value = (modelName != null) ? modelName : 'Unknown';
    }

    function updateSPPPplanDropdown(_availablePlans) {
        _availablePlans.forEach(function (e) {
            var option = document.createElement("option");
            option.text = e;
            option.value = e;
            $planDropdown[0].add(option);
        });
    }

    function displayInfoPanelwithWarnMsg() {
        $spInfoPanel.innerHTML = 'Sorry, we can\'t validate your registration at this time, please contact us.';
        $spInfoPanel.style.display = "block";
    }

    function updateServicePaymentPlanInfoText(_selectedPlan, _modelName, _flexTerm) {
        var _infoTxt = 'Model: ' + _modelName + '<br />Your vehicle is eligible to purchase a Volkswagen Scheduled Service Plan <br /><br />';

        if (!_selectedPlan) {
            flexTermWrapper[0].style.display = "none";
            return _infoTxt;
        }

        flexTermWrapper[0].style.display = "block";

        if (priceList != null) {
            var found = Object.keys(priceList).find(e => _selectedPlan.includes(e));

            var _payEachTerm = (priceList[found].Price / _flexTerm).toFixed(2);            

            var _amountMonthly = '$' + _payEachTerm + '/monthly';
            $('#amount-monthly')[0].innerText = _amountMonthly;            

            switch (_selectedPlan.charAt(0)) {
                case '3':
                case '6':
                    _infoTxt = _infoTxt + _selectedPlan + ' Scheduled Service Plan Cost: $' + _payEachTerm + '/monthly over ' + _flexTerm +' months. <br />'
                        + 'Inclusions: <br />'
                        + 'Comprehensive 30-point safety inspection, a diagnostic and software check and the services listed below. <br />'
                        + '• First Service - ' + priceList[found].FirstServiceInclusions + '<br />'
                        + '• Second Service - ' + priceList[found].SecondServiceInclusions + '<br />'
                        + '• Third Service - ' + priceList[found].ThirdServiceInclusions + '<br /><br />';                    
                    break;
                case '2':
                case '4':
                    _infoTxt = _infoTxt + _selectedPlan + ' Scheduled Service Plan Cost: $' + _payEachTerm + '/monthly over ' + _flexTerm +' months. <br />'
                        + 'Inclusions: <br />'
                        + 'Comprehensive 30-point safety inspection, a diagnostic and software check and the services listed below. <br />'
                        + '• First Service - ' + priceList[found].FirstServiceInclusions + '<br />'
                        + '• Second Service - ' + priceList[found].SecondServiceInclusions + '<br /><br />';
                    break;
                case '5':
                    _infoTxt = _infoTxt + _selectedPlan + ' Scheduled Service Plan Cost: $' + _payEachTerm + '/monthly over ' + _flexTerm +' months. <br />'
                        + 'Inclusions: <br />'
                        + 'Comprehensive 30-point safety inspection, a diagnostic and software check and the services listed below. <br />'
                        + '• First Service - ' + priceList[found].FirstServiceInclusions + '<br />'
                        + '• Second Service - ' + priceList[found].SecondServiceInclusions + '<br />'
                        + '• Third Service - ' + priceList[found].ThirdServiceInclusions + '<br />'
                        + '• Fourth Service - ' + priceList[found].FourthServiceInclusions + '<br />'
                        + '• Fifth Service - ' + priceList[found].FifthServiceInclusions + '<br /><br />';    
                    break;
            }


            if (modelName.toLowerCase().indexOf("amarok") > -1) {
                tcUrl = $form.attr('data-amarok-url');
            }
            else if ($vehicleType.value.includes("commercial")) {
                tcUrl = $form.attr('data-commercial-url');
            }
            else {
                tcUrl = $form.attr('data-passenger-url');
            }      

            if (tcUrl) {
                _infoTxt = _infoTxt + '<a href="' + tcUrl + '" target="_blank">Terms and conditions</a>';
            }
            
        }
        return _infoTxt;
    }

    function initMonthSlider() {
        noUiSlider.create($sliderFlexTerm, {
            range: {
                'min': 3,
                'max': 36
            },
            step: 1,
            start: [FALLBACK_TERM],
            connect: true,
            tooltips: false
        });

        $sliderFlexTerm.noUiSlider.on('update', function () {
            var _terms = $sliderFlexTerm.noUiSlider.get();
            selectedMonth = parseInt(_terms);
            //$sliderFlexTermLabel.text(`${parseInt(_terms)} months`);
            $sliderFlexTermLabel.text(`${selectedMonth}`);

            var _instalmentplan = $('.umbraco-forms-field.instalmentplan input:hidden')[0];
            _instalmentplan.value = selectedMonth;

            $spInfoPanel.innerHTML = updateServicePaymentPlanInfoText(selectedPlan, modelName, parseInt(selectedMonth));
        });
    }

    return {
        init: function () {            
            if (!$form.length) { return false; }

            initMonthSlider();
            $planDropdown = $(servicePlanDDWrapper).find('select');

            $($planDropdown).on('change', function () {
                selectedPlan = this.value;
                if (priceList != null) {
                    $spInfoPanel.innerHTML = updateServicePaymentPlanInfoText(this.value, modelName, selectedMonth);
                }                
            });

            $validateRegoBtn.on('click', function () {
                validateRego();                                
            });

            $submitBtn = $($form).find('.vw-formsubmit-button')[0];
            if ($submitBtn != null) {
                $submitBtn.closest('.forms-submit-row').style.cursor = 'not-allowed';
                $submitBtn.style.pointerEvents = 'none';
            }

            $($form).on('click', '.vw-formsubmit-button', function () {
                if (!selectedPlan) {
                    return;
                }

                var found = Object.keys(priceList).find(e => selectedPlan.includes(e));

                var _price = $('.umbraco-forms-field.price input:hidden')[0];
                _price.value = priceList[found].Price;

                var _subscriptionPrice = $('.umbraco-forms-field.subscriptionprice input:hidden')[0];
                _subscriptionPrice.value = (priceList[found].Price / selectedMonth).toFixed(2)

                if (priceList[found].FirstServiceInclusions) {
                    var _spInclusions = $('.umbraco-forms-field.inclusions1 input:hidden')[0];
                    _spInclusions.value = 'First service - ' + priceList[found].FirstServiceInclusions;
                }

                if (priceList[found].SecondServiceInclusions) {
                    var _spInclusions2 = $('.umbraco-forms-field.inclusions2 input:hidden')[0];
                    _spInclusions2.value = 'Second service - ' + priceList[found].SecondServiceInclusions;
                }

                if (priceList[found].ThirdServiceInclusions) {
                    var _spInclusions3 = $('.umbraco-forms-field.inclusions3 input:hidden')[0];
                    _spInclusions3.value = 'Third service - ' + priceList[found].ThirdServiceInclusions;
                }

                if (priceList[found].FourthServiceInclusions) {
                    var _spInclusions4 = $('.umbraco-forms-field.inclusions4 input:hidden')[0];
                    _spInclusions4.value = 'Fourth service - ' + priceList[found].FourthServiceInclusions;
                }

                if (priceList[found].FifthServiceInclusions) {
                    var _spInclusions5 = $('.umbraco-forms-field.inclusions5 input:hidden')[0];
                    _spInclusions5.value = 'Fifth service - ' + priceList[found].FifthServiceInclusions;
                }
                
            });

        }
    };
}());

VOLKSWAGEN.ServicePlanPaymentPlans.init();


VOLKSWAGEN.Merchandise = (function () {
    var $selectedVehicleNames = [];
    var $rangeTotalModels = $('.js-total-models');
    var $filterTerm = $('.filter-term');
    var $filterResetBtn = $('.js-reset-filter');
    var $selectedModelsWrap = $('.selected-models-wrap');

    var $mobileFilterPanel = $('.mobile-filter-panel');
    var $mobileFilterClose = $('.mobile-filter-panel .close');
    var $mobileOpenFilter = $('.mobile-open-filter');
    var $mobileResultsButton = $('.mobile-results-button');
    var nodeId = 0;
    var totalModels = 0;
    var currentTotalModels = 0;
    var $selectedRangeNames = [];

    function initTotalModels() {
        var rangeTabs = document.querySelectorAll('input[type="checkbox"][name="range"]');
        rangeTabs.forEach(function (e) {
            totalModels += parseInt($(e).attr('data-rangeCount'));
        });
        $rangeTotalModels.each(function () {
            $(this).text(totalModels);
        });
    }

    function toggleRange() {
        $('input[type="checkbox"][name="range"]').on('change', function () {
            var _rangeName = this.value;
            var _rangeCount = $(this).attr('data-rangeCount');

            var i = $selectedRangeNames.indexOf(_rangeName);
            if (i > -1) {
                $selectedRangeNames.splice(i, 1);
                currentTotalModels -= parseInt(_rangeCount);
            }
            else {
                $selectedRangeNames.push(_rangeName);
                currentTotalModels += parseInt(_rangeCount);
            }

            loadProductList($selectedRangeNames, $selectedVehicleNames, nodeId).then(function (data) {
                $('#car-tiles').html(data);
            }).catch(function (err) {
                console.log(err);
            });

            if (currentTotalModels > 0) {
                $filterResetBtn[0].style.display = 'inline-block';
            }
            else {
                $filterResetBtn[0].style.display = 'none';
            }

            var newModelCount = (currentTotalModels == 0) ? totalModels : currentTotalModels;
            $rangeTotalModels.each(function () {
                $(this).text(newModelCount);
            });

            if (currentTotalModels == 1) { $filterTerm[0].innerText = 'model'; } else { $filterTerm[0].innerText = 'models'; }

        });
    }
    

    function loadProductList(_rangeArr, _selectedModelArr, _nodeId) {
        return new Promise(function (resolve, reject) {
            var _url = '/app/nz/api/vehicles/productTiles';
            $.ajax({
                type: 'GET',
                url: _url,
                data: {
                    "rangeArr": JSON.stringify(_rangeArr),
                    "selectedModels": JSON.stringify(_selectedModelArr),
                    "nodeId": _nodeId
                },
                success: function (data) {
                    resolve(data);
                },
                error: function (err) {
                    reject(err);
                }
            });
        });
    }   

    function filterReset() {
        //reset all range checkboxes
        var _rangeLinks = document.querySelectorAll('.CustomStyledCheckboxControl .StyledInput');
        _rangeLinks.forEach(function (e) {
            $(e)[0].checked = false;
        });

        $selectedRangeNames = [];
        currentTotalModels = 0;

        $rangeTotalModels.each(function () {
            $(this).text(totalModels);
        });

        if (totalModels == 1) { $filterTerm[0].innerText = 'model'; } else { $filterTerm[0].innerText = 'models'; }
        $filterResetBtn[0].style.display = 'none';

        loadProductList($selectedRangeNames, $selectedVehicleNames, nodeId).then(function (data) {
            $('#car-tiles').html(data);
        }).catch(function (err) {
            console.log(err);
        });
        
    }

    function mobileFilterOpen() {
        $mobileFilterPanel.fadeIn(160);
    }

    function mobileFilterClose() {
        $mobileFilterPanel.fadeOut(160);
    }


    return {
        init: function () {
            
            var _mWrapper = $('.js-merchandise-wrapper');
            if (!_mWrapper.length) { return false; }

            $filterResetBtn[0].style.display = 'none';
            $selectedModelsWrap[0].style.display = 'none';
            nodeId = $(_mWrapper).attr('data-nodeId');

            initTotalModels();
            loadProductList($selectedRangeNames, $selectedVehicleNames, nodeId).then(function (data) {
                $('#car-tiles').html(data);

            }).catch(function (err) {
                console.log(err);
            });

            toggleRange();

            $filterResetBtn.on('click', function () {
                filterReset();
            });

            $mobileOpenFilter.on('click', function () {
                mobileFilterOpen();
            });

            $mobileFilterClose.on('click', function () {
                mobileFilterClose();
            });

            $mobileResultsButton.on('click', function () {
                mobileFilterClose();
            });

        }
    };

}());

VOLKSWAGEN.Merchandise.init();


VOLKSWAGEN.ServicePlanComparison = (function () {
    var $wrapper = $('#serviceplantool');
    var $showPlanBtn = null;

    var $regoSuccessMsg = $('.js-sptool-rego-success-msg');
    var $regoErrorMsg = $('.js-sptool-rego-error-msg');
    var $codeErrorMsg = $('.js-sptool-code-error-msg');

    const PAYMENT = {
        MONTHLY: 'Monthly', ONEOFF: 'One-off'
    };
    var allData = [];
    var currentVariantList = null;
    var selectedMV = {};
    var toolData = new Object();    
    var userChoice = new Object();
    
    const FALLBACK_TERM = 12;
    var flexTermWrapper = null;
    var $sliderFlexTermLabel = null;
    var $sliderFlexTerm = null;

    function loadSPToolData() {
        return new Promise(function (resolve, reject) {
            var _url = '/app/nz/api/vehicles/modelWithVariants';
            $.ajax({
                type: 'GET',
                url: _url,
                success: function (data) {
                    resolve(data);
                },
                error: function (err) {
                    reject(err);
                }
            });
        });
    }

    function monitorToolData(_wrapper) {
        var rego = _wrapper.find('input[name="sp-rego"]')[0];
        toolData.rego = rego.value;

        var model = _wrapper.find('select[name="sp-model"]')[0];
        toolData.modelName = model.value;

        var variant = _wrapper.find('select[name="sp-variant"]')[0];
        toolData.variant = variant.value;

        // update btn state
        if (toolData.rego.length > 0 || (toolData.modelName.length > 0 && toolData.variant.length > 0)) {
            $showPlanBtn.closest('.forms-submit-row').style.cursor = 'pointer';
            $showPlanBtn.style.pointerEvents = 'auto';
        }
        else {
            $showPlanBtn.closest('.forms-submit-row').style.cursor = 'not-allowed';
            $showPlanBtn.style.pointerEvents = 'none';
        }
    }

    function togglePaymentHandler() {
        const el = document.getElementById('plan-switch');

        el.addEventListener("click", function () {            
            if ($(this).is(':checked')) {
                flexTermWrapper[0].style.display = 'block'; // show slider
                
                userChoice.paymentType = PAYMENT.MONTHLY;
                updatePaymentTypeCss();
                updatePricingLabels();
            }
            else {
                flexTermWrapper[0].style.display = 'none'; // hide slider
               
                userChoice.paymentType = PAYMENT.ONEOFF;
                updatePaymentTypeCss();
                updatePricingLabels();
            }

        }, false);
    }

    function purchasePlanHandler() {

        $('.js-btn-plan').on('click', function () {
            if (userChoice.validRego) {
                userChoice.planDuration = $(this).attr('data-planduration');
                localStorage.setItem('vwServicePlan', JSON.stringify(userChoice));
            }
            else {
                localStorage.setItem('vwServicePlan', null);
            }

            var _step2PageUrl= $(this).attr('data-url');
            if (_step2PageUrl) {
                window.location.href = _step2PageUrl;
            }
        });
    }

    function collectVehicleData(_registration) {
        userChoice.rego = _registration;
        userChoice.modelName = $('#sp-modelName').val();
        userChoice.modelFullName = $('#sp-fullVehicleName').val();
        userChoice.modelCode = $('#sp-modelCode').val();
        userChoice.modelType = $('#sp-modelType').val();
        userChoice.imageUrl = $('#sp-imageUrl').val();
    }

    function hasRego() {
        var _rego = toolData.rego;

        if (typeof (_rego) == 'undefined' || _rego == null || _rego == '') {
            return false;
        }

        toolData.rego = _rego.replace(/\s+/g, '').toUpperCase();        
        return true;
    }

    function hasModelVariant() {
        if (toolData.modelName != '' && toolData.variant != '') {
            return true;
        }
        return false;
    }

    function getPlansByRego(_rego, _id) {

        _rego = _rego.replace(/\s+/g, '');
        
        var _url = '/app/nz/api/servicepackage/plans-by-rego?rego=' + _rego + '&nodeId=' + _id;
        $.ajax({
            type: 'GET',
            url: _url,
            success: function (data) {
                $('#eligible-plans').html(data);                

                if ($('#sp-isEligible').val() == "True") { // has eligible plans
                    $('#sp-rego').prop('readonly', true);

                    $regoSuccessMsg.html($regoSuccessMsg.html().replace("{carModel}", $('#sp-fullVehicleName').val()));
                    $regoSuccessMsg.css('display', 'initial');
                    $regoErrorMsg.css('display', 'none');

                    initPaymentDurationSlider();
                    togglePaymentHandler();
                    purchasePlanHandler();

                    $('.js-sptool-hline').css('display', 'none');
                    $('.js-sptool-mv-wrapper').css('display', 'none');
                    $showPlanBtn.style.display = 'none';

                    userChoice.validRego = true;
                    collectVehicleData(_rego);

                    displayThumbnailView(userChoice.modelCode, userChoice.modelName);

                    initServiceComparisonMobileSlider();

                } else {
                    $regoSuccessMsg.css('display', 'none');
                    $regoErrorMsg.css('display', 'initial');
                }
                   
            },
            error: function (response) {
                console.log(response);
            }
        });        
    }

    function getPlansByCode(_code, _id) {
        var _url = '/app/nz/api/servicepackage/plans-by-code?code=' + _code + '&nodeId=' + _id;

        $.ajax({
            type: 'GET',
            url: _url,
            success: function (data) {               
                $('#eligible-plans').html(data);

                if ($('#sp-isEligible').val() == "True") { // has eligible plans
                    userChoice.paymentType = PAYMENT.ONEOFF;
                    initPaymentDurationSlider();
                    togglePaymentHandler();
                    purchasePlanHandler();

                    $('.js-sptool-hline').css('display', 'none');
                    $('.js-sptool-rego-wrapper').css('display', 'none');
                    $showPlanBtn.style.display = 'none';

                    userChoice.validRego = false;
                    displayThumbnailView($('#sp-modelCode').val(), $('#sp-modelName').val());

                    initServiceComparisonMobileSlider();

                } else {
                    $codeErrorMsg.css('display', 'initial');
                }
            },
            error: function (response) {
                console.log(response);
            }
        });
    }

    function displayThumbnailView(_code, _name) {
        var _url = '/app/nz/api/servicepackage/thumbnail?code=' + _code + '&name=' + _name;
        $.ajax({
            type: 'GET',
            url: _url,
            success: function (data) {
                $('#vw-model-thumb').html(data);
            },
            error: function (response) {
                console.log(response);
            }
        });

    }

    function initServiceComparisonMobileSlider() {
        new ComparisonSlider('*[data-component="c-service-comparison-mobile-slider"]', document);
    }

    function initPaymentDurationSlider() {
        flexTermWrapper = $('#js-sp-term-wrapper');
        $sliderFlexTerm = document.getElementById('sp-flex-term-range');
        $sliderFlexTermLabel = $('.js-flex-term-label');

        noUiSlider.create($sliderFlexTerm, {
            range: {
                'min': 3,
                'max': 36
            },
            step: 1,
            start: [FALLBACK_TERM],
            connect: 'lower',
            tooltips: false
        });

        $sliderFlexTerm.noUiSlider.on('update', function () {
            var _terms = $sliderFlexTerm.noUiSlider.get();
            userChoice.selectedTerm = parseInt(_terms);
            $sliderFlexTermLabel.text(`${userChoice.selectedTerm}`);

            updatePricingLabels();
        });
    }

    function updatePaymentTypeCss() {
        var _oneoff = $('.js-oneOff-payment');
        var _monthly = $('.js-monthly-payment');

        var _disableStyle = { 'color': '#ccc', 'pointer-events': 'all' };
        var _enableStyle = { 'color': '#001e50', 'pointer-events': 'none' };

        if (userChoice.paymentType == PAYMENT.MONTHLY) {
            _oneoff.css(_disableStyle);
            _monthly.css(_enableStyle);
        }
        else {
            _oneoff.css(_enableStyle);
            _monthly.css(_disableStyle);
        }
    }

    function updatePricingLabels() {
        var _pricingLabels = document.querySelectorAll('.js-pricing');
        if (userChoice.paymentType == PAYMENT.MONTHLY) {

            _pricingLabels.forEach(function (e) {
                var _totalPrice = parseInt($(e).attr('data-totalPrice'));
                var _amountMonthly = '$' + currencyFormat((_totalPrice / userChoice.selectedTerm).toFixed(2)) + '/monthly';
                $(e).text(_amountMonthly);
            });
        }
        else {
            _pricingLabels.forEach(function (e) {
                var _total = '$' + currencyFormat(parseInt($(e).attr('data-totalPrice')));
                $(e).text(_total);
            });
        }
    }

    return {
        init: function () {
            if (!$wrapper.length) { return false; }

            userChoice.validRego = false;
            userChoice.paymentType = PAYMENT.ONEOFF;
            userChoice.selectedTerm = FALLBACK_TERM;

            $showPlanBtn = $('.js-showplan-btn')[0];

            var _modelCode = getURLParameter('modelcode');
            var _foundModel = null;
            var _foundVariant = null;

            monitorToolData($wrapper);

            loadSPToolData().then(function (data) {
                allData = data;

                var _models = [];
                allData.forEach(function (e) {
                    _models.push(e.FixedModelName);
                });
                updateDropdown('sp-model', 'Select model', _models, false);

                if (!!_modelCode) {
                    var _found = false;
                    for (var i = 0; i < allData.length; i++) {
                        allData[i].Variants.find(function (v) {
                            if (v.ModelCode == _modelCode) {
                                _foundModel = allData[i].FixedModelName;
                                _foundVariant = v.VariantName;
                                return;
                            }
                        });

                        if (_foundModel && _foundVariant) {
                            _found = true;
                            //console.log('Model: ' + _foundModel + ', Variant: ' + _foundVariant);
                            break;
                        }
                    }

                    if (_found) {
                        $('#sp-model').val(_foundModel);
                        $('#sp-model').trigger('change');

                        $('#sp-variant').val(_foundVariant);
                        $('#sp-variant').trigger('change');

                        monitorToolData($wrapper);
                        $($showPlanBtn).trigger('click');
                    }                    
                }
            });       

            $($wrapper).on('input', '#sp-rego', function () {
                monitorToolData($wrapper);
            });

            $($wrapper).on('change', '#sp-model', function () {
                //console.log('model change..... selected MODEL: ' + $(this).val());
                $codeErrorMsg.css('display', 'none');
                $showPlanBtn.style.display = 'initial';                
                $('#eligible-plans').html('');
                //$('#vw-model-thumb').html('');

                var _val = $(this).val();
                if (_val != '') {

                    var _found = allData.find(function (item) {
                        return item.FixedModelName == _val;
                    });

                    console.log(_found);
                    currentVariantList = _found.Variants;

                    var _variants = [];
                    _found.Variants.forEach(function (e) {
                        _variants.push(e.VariantName);
                    });

                    updateDropdown('sp-variant', 'Select variant', _variants, false);                    

                     // if only one variant, auto selcted
                    if (_found.Variants.length == 1) {
                        toolData.ModelCode = _found.Variants[0].ModelCode;
                        selectedMV = _found.Variants[0];
                        $('#sp-variant').trigger('change');
                    }
                }
                else {
                    updateDropdown('sp-variant', 'Select variant', ['Select variant'], true);
                }

                monitorToolData($wrapper);
            });

            $($wrapper).on('change', '#sp-variant', function () {
                //console.log('variant change..... selected VARIANT: ' + $(this).val());
                $codeErrorMsg.css('display', 'none');
                $showPlanBtn.style.display = 'initial';
                $('#eligible-plans').html('');
                //$('#vw-model-thumb').html('');
                
                var _val = $(this).val();
                var _found = currentVariantList.find(function (v) {
                    return v.VariantName == _val;
                });
                
                selectedMV = _found;
                monitorToolData($wrapper);
            });
           

            $($showPlanBtn).on('click', function () {
                event.preventDefault();                
                var _id = $wrapper.attr('data-nodeId');

                if (hasRego()) {
                    //console.log('has Rego ...........');
                    getPlansByRego(toolData.rego, _id);
                }
                else if(hasModelVariant()){
                    //console.log('has M+V ...........' + selectedMV.ModelCode);
                    getPlansByCode(selectedMV.ModelCode, _id);
                }
                else {
                    console.log('do nothing');
                }
                return false;
            });

        }
    };

}());

VOLKSWAGEN.ServicePlanComparison.init();


VOLKSWAGEN.ServicePackage = (function () {
    var $wrapper = $('.js-service-package-wrapper');
    var $form = $('#servicePackage');
    var $btnSubmit = null; //form

    const PAYMENT = {
        MONTHLY: 'Monthly', ONEOFF: 'One-off'
    };
    
    var $rego = $('#sp-rego');
    var $btnValidateRego = $('#js-validate-rego');
    var $ddPlanDuration = $('#sp-plan');
    var $planSwitch = $('#plan-switch');
    var $termWrapper = $('#js-package-term-wrapper');    
    
    const FALLBACK_TERM = 12;
    var $sliderFlexTerm = document.getElementById('package-flex-term-range');
    var $sliderFlexTermLabel = $('.js-flex-term-label');

    var $regoErrorMsg = $('.js-package-error-msg');
    var $regoWarnMsg = $('.js-package-warn-msg');
    var $vehicleInfo = $('.js-vehicle-info');
    var $packageInfoPanel = $('.js-plan-info-msg');

    var packageData = new Object();
    var $planList = null;

    function loadVehicleServicePlanData() {

        if (locaStorageHasData()) {
            var _vehicleData = JSON.parse(localStorage['vwServicePlan']);
            //console.log({ _vehicleData });

            initTermSlider(_vehicleData.selectedTerm);
            packageData.paymentType = _vehicleData.paymentType;
            packageData.term = _vehicleData.selectedTerm;

            if (_vehicleData.validRego && _vehicleData.rego) {

                $rego.val(_vehicleData.rego);

                // use rego to get eligible plans from CRM
                var _url = '/app/nz/api/purchaseservice/eligible-plans?code=' + _vehicleData.modelCode;
                $.ajax({
                    type: 'POST',
                    url: _url,
                    success: function (response) {
                        //console.log(response);
                        var _mappedData = storageDataMapper(_vehicleData);

                        handleEligiblePlanView(response, _mappedData);                      
                    },
                    error: function (response) {
                        console.log(response);
                    }
                });
                
                
                $planSwitch.prop('checked', (_vehicleData.paymentType == PAYMENT.MONTHLY) ? true : false);
                updatePaymentTypeCss();
                $termWrapper.css('display', (_vehicleData.paymentType == PAYMENT.MONTHLY) ? 'block' : 'none');
            }
            else {
                //hide all fields except 'rego' and 'validate btn'
            }
        }
        else {
            initTermSlider(FALLBACK_TERM);            
            packageData.paymentType = PAYMENT.MONTHLY;
            packageData.term = FALLBACK_TERM;
            updatePaymentTypeCss();

            $ddPlanDuration.css('display', 'none');
            $vehicleInfo.css('display', 'none');
        }

        termSliderEventHandler(); //
    }

    function validateRego(_rego) {
        if (typeof (_rego) == 'undefined' || _rego == null || _rego == '') {
            console.log('Required Rego');
            return;
        }

        _rego = _rego.replace(/\s+/g, '').toUpperCase();

        var _url = '/app/nz/api/purchaseservice/validate?rego=' + _rego;
        $.ajax({
            type: 'POST',
            url: _url,
            success: function (response) {
                //console.log(response);

                getThumbnailUrl(response.ServicePlanModelCode, function (_imageUrl) {
                    var _mappedData = regoApiResponseDataMapper(_rego, response, _imageUrl);
                    handleEligiblePlanView(response, _mappedData);                    
                });
                        
            },
            error: function (response) {
                console.log(response);
            }
        });

    }

    function storageDataMapper(_data) {
        var _model = {
            "rego": _data.rego,
            "modelName": _data.modelName,
            "modelFullName": _data.modelFullName,
            "modelCode": _data.modelCode,
            "modelType": _data.modelType,
            "imageUrl": _data.imageUrl,
            "planDuration": _data.planDuration
        };
        return _model;
    }

    function regoApiResponseDataMapper(_rego, _resp, _imgUrl) {
        var _model = {
            "rego": _rego,
            "modelName": _resp.VehicleModel,
            "modelFullName": _resp.FullVehicleName,
            "modelCode": _resp.ServicePlanModelCode,
            "modelType": _resp.VehicleType,
            "imageUrl": (_imgUrl != null) ? _imgUrl + "?width=690" : null,
            "planDuration": "" 
        };
        return _model;
    }   

    function getThumbnailUrl(_code, callback) {
        var _url = '/app/nz/api/purchaseservice/thumb?code=' + _code;
        $.ajax({
            type: 'GET',
            url: _url,
            success: function (data) {
                callback(data);
            },
            error: function (response) {
                console.log(response);
                callback(null);
            }
        });
    }

    function handleEligiblePlanView(_response, _mappedData) {
        if (_response.Eligible) {
            $rego.prop('readonly', true);
            $btnValidateRego.css('display', 'none');

            collectServicePackageData(_mappedData, _response);

            if (!_response.PriceList) {
                displayRegoWarnMsg();
            }
            else {
                var _plans = Object.keys(_response.PriceList);
                updateDropdown('sp-plan', 'Plan type', _plans, false);
                $ddPlanDuration.css('display', 'block');


                if (_plans.includes(_mappedData.planDuration)) {                    
                    $ddPlanDuration.val(_mappedData.planDuration);
                    packageData.planDuration = _mappedData.planDuration;
                }
                else {
                    $ddPlanDuration.val(_plans[0]);
                    packageData.planDuration = _plans[0];
                }

                $ddPlanDuration.trigger('change');                

                $('.js-vehicle-model').text(_mappedData.modelName);

                if (_mappedData.imageUrl != 'null' && _mappedData.imageUrl != 'null?width=690') {
                    $('.js-vehicle-thumb > img').attr('src', _mappedData.imageUrl);
                }
                else {
                    $('.js-vehicle-thumb > img').css('display', 'none');
                }

                if ($(window).width() > 959) {
                    $vehicleInfo.css('display', 'flex');
                }
                else {
                    $vehicleInfo.css('display', 'block');
                }


                $packageInfoPanel.html(updatePackageInfoText());

                var _formWarnMsg = $($form).find('.umbraco-forms-field.warningmessage');
                _formWarnMsg.css('display', 'none');
                $btnSubmit.closest('.forms-submit-row').style.cursor = 'pointerd';
                $btnSubmit.style.pointerEvents = 'auto';
            }
        }
        else {
            //not eligible
            displayRegoErrorMsg();
        }
    }

    function collectServicePackageData(_vData, _resp) {
        $planList = _resp.PriceList;
        
        packageData.rego = _vData.rego;
        packageData.imageUrl = _vData.imageUrl;
        packageData.fullName = _vData.modelFullName;
        packageData.modelName = _vData.modelName;
        packageData.modelCode = _vData.modelCode;
        packageData.vehicleType = _vData.modelType;        
    }

    function displayRegoWarnMsg() {
        $regoWarnMsg.css('display', 'block');
    }
    function displayRegoErrorMsg() {
        $regoErrorMsg.css('display', 'block');
    }

    function updatePackageInfoText() {
        if (!packageData.planDuration) {
            //console.log('No selected plan');
            $packageInfoPanel.css('display', 'none');
            return '';
        }

        if ($planList == null) {
            console.log('No plan from CRM');
            $packageInfoPanel.css('display', 'none');
            return '';
        }

        $packageInfoPanel.css('display', 'block');

        var _found = Object.keys($planList).find(e => packageData.planDuration.includes(e));
        var _payEachTerm = ($planList[_found].Price / packageData.term).toFixed(2);

        var _amount = (packageData.paymentType == PAYMENT.MONTHLY)
            ? '$' + currencyFormat(_payEachTerm) + '/monthly'
            : '$' + currencyFormat(parseInt($planList[_found].Price));

        var _infoTxt = '<h4>' + _amount + '</h4>' + '<h3>' + packageData.planDuration + '</h3> <hr /> <br />';
        _infoTxt = _infoTxt + '<h5>Inclusions: </h5>'
            + '<p>Comprehensive 30-point safety inspection, a diagnostic and software check and the services listed below. </p>';

        switch (packageData.planDuration.charAt(0)) {
            case '2':
                _infoTxt = _infoTxt +
                    '<p><strong>First Service</strong> - ' + $planList[_found].FirstServiceInclusions + '</p>'
                    + '<p><strong>Second Service</strong> - ' + $planList[_found].SecondServiceInclusions + '</p>';
                break;
            case '3':
                _infoTxt = _infoTxt +
                    '<p><strong>First Service</strong> - ' + $planList[_found].FirstServiceInclusions + '</p>'
                    + '<p><strong>Second Service</strong> - ' + $planList[_found].SecondServiceInclusions + '</p>'
                    + '<p><strong>Third Service</strong> - ' + $planList[_found].ThirdServiceInclusions + '</p><br />';
                break;
            case '5':
                _infoTxt = _infoTxt +
                    '<p><strong>First Service</strong> - ' + $planList[_found].FirstServiceInclusions + '</p>'
                    + '<p><strong>Second Service</strong> - ' + $planList[_found].SecondServiceInclusions + '</p>'
                    + '<p><strong>Third Service</strong> - ' + $planList[_found].ThirdServiceInclusions + '</p>'
                    + '<p><strong>Fourth Service</strong> - ' + $planList[_found].FourthServiceInclusions + '</p>'
                    + '<p><strong>Fifth Service</strong> - ' + $planList[_found].FifthServiceInclusions + '</p><br />';            
                break;
            default:
                break;
        }

        var tcUrl = null;
        if (packageData.modelName.toLowerCase().indexOf("amarok") > -1) {
            tcUrl = $form.attr('data-amarok-url');
        }
        else if (packageData.vehicleType.includes("commercial")) {
            tcUrl = $form.attr('data-commercial-url');
        }
        else {
            tcUrl = $form.attr('data-passenger-url');
        }

        if (tcUrl) {
            _infoTxt = _infoTxt + '<p><a href="' + tcUrl + '" target="_blank">Terms and conditions</a></p><br/><hr/>';

            // override
            var checkboxCaption = $form.find('.umbraco-forms-field.agreetc .StyledTextComponent');
            checkboxCaption.html('I have read and accept the <a href="' + tcUrl + '" target="_blank">Terms and conditions</a> *');
        }

        updatePackageFormHiddenFields($form, $planList[_found], _payEachTerm);

        return _infoTxt;
    }

    function updatePaymentTypeCss() {
        var _oneoff = $('.js-oneOff-payment');
        var _monthly = $('.js-monthly-payment');

        var _disableStyle = { 'color': '#ccc', 'pointer-events': 'all' };
        var _enableStyle = { 'color': '#001e50', 'pointer-events': 'none'};

        if (packageData.paymentType == PAYMENT.MONTHLY) {
            _oneoff.css(_disableStyle);
            _monthly.css(_enableStyle);

            $termWrapper.css('display', 'block');
        }
        else {
            _oneoff.css(_enableStyle);
            _monthly.css(_disableStyle);

            $termWrapper.css('display', 'none');
        }
    }

    function initTermSlider(_defaultTerm) {
        noUiSlider.create($sliderFlexTerm, {
            range: {
                'min': 3,
                'max': 36
            },
            step: 1,
            start: [_defaultTerm],
            connect: 'lower',
            tooltips: false
        });
    }

    function termSliderEventHandler() {
        $sliderFlexTerm.noUiSlider.on('update', function () {
            var _terms = $sliderFlexTerm.noUiSlider.get();
            packageData.term = parseInt(_terms);
            $sliderFlexTermLabel.text(`${packageData.term}`);
            
            $packageInfoPanel.html(updatePackageInfoText());
        });
    }

    function updatePackageFormHiddenFields(_form, _selectedPlan, _payEachTerm) {

        var registration = _form.find('.umbraco-forms-field.carregistration input:hidden');
        registration.val(packageData.rego);

        var planDuration = _form.find('.umbraco-forms-field.serviceplanduration input:hidden');
        planDuration.val(packageData.planDuration);

        var paymentType  = _form.find('.umbraco-forms-field.paymenttype input:hidden');
        paymentType.val(packageData.paymentType);

        var price = _form.find('.umbraco-forms-field.price input:hidden');
        price.val(_selectedPlan.Price);

        var monthlyPrice = _form.find('.umbraco-forms-field.subscriptionprice input:hidden');
        monthlyPrice.val(_payEachTerm);

        var term = _form.find('.umbraco-forms-field.term input:hidden');
        term.val(packageData.term);

        var modelName = _form.find('.umbraco-forms-field.carmodel input:hidden');
        modelName.val(packageData.modelName); // or full model name

        var modelCode = _form.find('.umbraco-forms-field.modelcode input:hidden');
        modelCode.val(packageData.modelCode);

        var thumbnail = _form.find('.umbraco-forms-field.thumbnail input:hidden');
        var _imgUrl = null;
        if (packageData.imageUrl != null) {
            _imgUrl = window.location.origin + packageData.imageUrl;
        }
        thumbnail.val(_imgUrl);        

        var vehicletype = _form.find('.umbraco-forms-field.vehicletype input:hidden');
        vehicletype.val(packageData.vehicleType);        

        var inclusions1  = _form.find('.umbraco-forms-field.inclusions1 input:hidden');
        inclusions1.val(_selectedPlan.FirstServiceInclusions);

        var inclusions2 = _form.find('.umbraco-forms-field.inclusions2 input:hidden');
        inclusions2.val(_selectedPlan.SecondServiceInclusions);

        var inclusions3 = _form.find('.umbraco-forms-field.inclusions3 input:hidden');
        inclusions3.val(_selectedPlan.ThirdServiceInclusions);

        var inclusion4 = _form.find('.umbraco-forms-field.inclusions4 input:hidden');
        inclusion4.val(_selectedPlan.FourthServiceInclusions);

        var inclusion5 = _form.find('.umbraco-forms-field.inclusions5 input:hidden');
        inclusion5.val(_selectedPlan.FifthServiceInclusions);
    }

    function locaStorageHasData() {
        if (localStorage.getItem('vwServicePlan')) {

            if (!JSON.parse(localStorage['vwServicePlan'])) {                
                return false;
            }

            return true;
        }
        else {
            return false;
        }
    }

    return {
        init: function () {            
            if (!$wrapper.length) { return false; }
            if (!$form.length) { return false; }

            $btnSubmit = $($form).find('.vw-formsubmit-button')[0];
            if ($btnSubmit != null) {
                $btnSubmit.closest('.forms-submit-row').style.cursor = 'not-allowed';
                $btnSubmit.style.pointerEvents = 'none';
            }

            loadVehicleServicePlanData();

            $planSwitch.on("click", function () {
                if ($(this).is(':checked')) {
                    packageData.paymentType = PAYMENT.MONTHLY;
                }
                else {
                    packageData.paymentType = PAYMENT.ONEOFF;                    
                }

                updatePaymentTypeCss();
                $packageInfoPanel.html(updatePackageInfoText());
            });

            $ddPlanDuration.on('change', function () {
                //console.log('plan change.....: ' + $(this).val());
                var _val = $(this).val();

                packageData.planDuration = _val;
                $packageInfoPanel.html(updatePackageInfoText());                
            });

            $btnValidateRego.on('click', function () {
                validateRego($rego.val());
            });

        }
    };
}());

VOLKSWAGEN.ServicePackage.init();